import React, { useRef ,useState, useEffect, useCallback  } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faPlusCircle, faQuestionCircle, faTrash, faX, faExclamationTriangle, faInfoCircle, faSave } from '@fortawesome/free-solid-svg-icons';
import useCommonResponseHandler from '../CommenResponseAndErrorHandlers/CommenResponseHandler';
import { Loader, Spinner } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages'
import TableSearchDropDown from '../Components/TableSearchDropDownForSalesOrder';
import TableSearchForAreaName from '../Components/TabelSerchForAreaName'
import  '../Css/Tooltip.css';
import {useLocation, useNavigate } from 'react-router-dom';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';

// Custom hook to handle outside clicks
const useOutsideClick = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }        
  };

  React.useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
};

const CustomDropdown = ({ options, selected, onSelect, showAddNew, placeholder, showSearch }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = React.useRef(null);

  const filteredOptions = options.filter(option => {
    if (!option || !option.label) return false;
    return option.label.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const handleOptionClick = (option) => {
    onSelect(option); // Pass the entire option object
    setIsOpen(false);
  };

  useOutsideClick(dropdownRef, () => setIsOpen(false));

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        className="flex justify-between items-center p-2 border bg-white border-gray-300 rounded-md cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`text-sm ${selected ? 'text-black' : 'text-[#838195]'}`}>
          {selected?.label || placeholder} {/* Use selected.label if selected is an object */}
        </span>
        <FontAwesomeIcon icon={faChevronDown} className="w-3 h-3 text-gray-500" />
      </div>
      {isOpen && (
        <div className="absolute mt-1 w-full max-h-40 bg-white border border-gray-300 rounded-md shadow-md z-10 flex flex-col">
          {showSearch && (
            <input
              type="text"
              className="p-1 border rounded-md border-blue-500 focus:outline-none hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          )}
          <div className="overflow-y-auto scrollbar-visible flex-grow">
            {filteredOptions.length > 0 ? (
              filteredOptions.map(option => (
                <div
                  key={option.value}
                  className="p-2 cursor-pointer text-sm hover:bg-blue-500 hover:text-white"
                  onClick={() => handleOptionClick(option)}
                >
                  {option.icon && <FontAwesomeIcon icon={option.icon} className="mr-2" />}
                  {option.label}
                </div>
              ))
            ) : (
              <div className="p-2 text-sm text-gray-500">
                Not available
              </div>
            )}
          </div>
          {showAddNew && (
            <div
              className="p-2 cursor-pointer text-sm text-blue-500 border-t border-gray-300"
              onClick={() => handleOptionClick({value: 'add-new', label: 'Add New'})}
            >
              {options.find(option => option.value === 'add-new')?.icon && (
                <FontAwesomeIcon
                  icon={options.find(option => option.value === 'add-new').icon}
                  className="mr-2"
                />
              )}
              {options.find(option => option.value === 'add-new')?.label}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const EditQuote = () => {
  const navigate = useNavigate ();
  const location= useLocation();
  const { QuoteID } = location.state || {};
  const [Quotation , setQuotation] = useState();
  const {package_id, project_id, product_category_id} = location.state || {};
  const [selectedProject, setSelectedProject] = useState(null);
const [selectedProjectId, setSelectedProjectId] = useState('');
const dropdownRef = useRef(null); // Define the dropdownRef variable
  const [quoteTypeOptions, setQuoteTypeOptions] = useState([
    { label: "General", value: "General" },
    { label: "Group", value: "Group" },
  ]);
  const [selectedQuoteType, setSelectedQuoteType] = useState(); // Initial value
  const [TaxOptions] = useState([
    {label: "Tax Exclusive", value: "Tax Exclusive"},
    {label: "Tax Inclusive", value: "Tax Inclusive"},
  ]);
  const [selectedTax, setSelectedTax] = useState();
  const [priceLists , setPriceLists] = useState([ ]);
  //console.log(priceLists);
  const[selectedPricList, setselectedPricList] = useState();
  const [UomOptions , setUomOptions] = useState([]);
  const [AreaMeasurementsData, setAreaMeasurementsData] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
 //console.log(selectedCustomer);
  const [quotationNumber, setQuotationNumber] = useState('');
  const [salesorderDate, setsalesorderDate] = useState(new Date());
  const [showDesignSelectPopup, setshowDesignSelectPopup] = useState(false);
  const [productCategories, setProductCategories] = useState([]);
  const [Summary , setSummary] =  useState({});
  const [selectedProductCategory, setSelectedProductCategory] = useState();
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const FetchProjectsUrl = process.env.REACT_APP_FORE_APILINK; //measurit
  const Taxes = [{name:'GST' , value: 'GST'},{name:'IGST' , value: 'IGST'}]
  const [SelectedItemRow,setSelectedItemRow] = useState()
const [SelectedItemRowIndex ,setSelectedItemRowIndex] = useState()
const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES; 
const [searchTerm, setSearchTerm] = useState('');
const [DefaultProductRatesOfPriceList,setDefaultProductRatesOfPriceList]= useState()
const [allRowsSelectedPriceList, setAllRowsSelectedPriceList] = useState([]);
  const [selectedDesigns, setSelectedDesigns] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [rowPricelists, setRowPricelists] = useState({});
  const [rows, setRows] = useState([{ item_name: '', item_id:'', application_area: {area_name:'',area: '', count:'',},  quantity: '', UOM: '', price: '', tax: '', amount: '', designs:[]}]);
  const [products, setProducts] = useState([]); // assume products is set to one of the arrays you provided
  const [amounts, setAmounts] = useState([]);
  const [items, setItems] = useState([{ tilesArea: '', doorsArea: '', windowsArea: '' }]);
  const [tilesOptions, setTilesOptions] = useState([]);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [adjustment, setAdjustment] = useState(0);
  const[ attributes, setAttributes]= useState([])
  const { 
    showPopup, popupMessage, popupType,retryFunction, handleGetResponse, handleSaveResponse, setShowPopup,
    isSaving, setRetryFunction, handleDeleteResponse,  setIsSaving ,    setPopupMessage,
    setPopupType } = useCommonResponseHandler();

    const RETRY_LIMIT = 3; // Maximum number of retries
    const [retryCount, setRetryCount] = useState(0); // Track retry attempts
    const [customersLoaded, setCustomersLoaded] = useState(false);
const [productCategoriesLoaded, setProductCategoriesLoaded] = useState(false);
const [QuotationItems ,setQuotationItems] = useState();
const  [SubTotal,setSubTotal]= useState(0)

const [total, setTotal] = useState(0);
const [amendedDiscount, setAmendedDiscount] = useState(0);
const [amendedPrice, setAmendedPrice] = useState();
const [selectedApplicationAreas, setSelectedApplicationAreas] = useState({});
const [roleId, setRoleId] = useState(null);
const [selectedSpecifications, setSelectedSpecifications] = useState(null);
const [selectedItemIndex, setSelectedItemIndex] = useState(null);
const [showSpecificationsPopup, setShowSpecificationsPopup] = useState(false);
const [quotationDate, setQuotationDate] = useState(new Date());
const [activeDropdown, setActiveDropdown] = useState(null);
const [showBreakdownForIndex, setShowBreakdownForIndex] = useState(null);
const [hasUnsavedChanges , setHasUnsavedChanges] = useState(false);
   
const [showAddonSelectionForIndex, setShowAddonSelectionForIndex] = useState(null);
const [selectedAddons, setSelectedAddons] = useState([]);
const [selectedVendor, setSelectedVendor] = useState(null);
const [vendors, setVendors] = useState([]);
const [groupedAddons, setGroupedAddons] = useState({});
const [isLoadingAddons, setIsLoadingAddons] = useState(false);
const [subcategoryAddons, setSubcategoryAddons] = useState({});
const [filteredSubcategoryAddons, setFilteredSubcategoryAddons] = useState({});



useEffect(() => {
      fetchRoleId();
      fetchAllApprovedCustomers();
      fetchProductCategories();
      handleGetAllUoms();
    }, [fetchUrl]);

    const fetchRoleId = () => {
      const roleId = JSON.parse(sessionStorage.getItem('roleId'));
      setRoleId(roleId);
    };
  
    const categoriesToDisplay = roleId === 6 
    ? productCategories.filter(category => (category.product_category_name.toLowerCase()) === 'tiles')
    : productCategories;

    useEffect(() => {
      if (customersLoaded && productCategoriesLoaded) {
        fetchQuotationById(customers);
      }
    }, [customersLoaded, productCategoriesLoaded]);
      
    const fetchAllApprovedCustomers = async (attempt = 1) => {
      try {
        const token = sessionStorage.getItem('token');
        const response = await fetch(fetchUrl + `customer/get-all-approved-customers?organizationId=${sessionStorage.getItem('organizationId')}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
        const data = await response.json();
        const output = await handleGetResponse(response, data);
        if (output) {
          // Format data for dropdown
          const formattedCustomers = output.map(customer => ({
            id: customer._id,  // Use customer ID as value
            label: customer.customer_name, // Use customer name as label
            value: customer.customer_name
          }));
    
          setCustomers(formattedCustomers); // Update state with formatted data
         // console.log(formattedCustomers);
         setCustomersLoaded(true);
        } else {
          handleFetchError(response, attempt, fetchAllApprovedCustomers);
        }
      } catch (error) {
        handleErrorWithRetry(error, attempt, fetchAllApprovedCustomers);
      }
    };

    const fetchProductCategories = async (attempt = 1) => {
      try {
        const token = sessionStorage.getItem('token');
        const response = await fetch(fetchUrl + "product-category/get-all-productCategories", {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
        const data = await response.json();
        const output = await handleGetResponse(response , data)
        //console.log(output)
        if (output) {
          setProductCategories(output); // Update productCategories state
          setProductCategoriesLoaded(true);
        }  else {
          handleFetchError(response, attempt, fetchProductCategories);
        }
      } catch (error) {
        handleErrorWithRetry(error, attempt, fetchProductCategories);
      }
    };

    const fetchQuotationById = async (customers, attempt = 1) => {
      if (!customersLoaded || !productCategoriesLoaded) {
        // If data isn't loaded yet, don't attempt to fetch the quotation
        return;
      }
      
      try {
        const token = sessionStorage.getItem('token');
        const response = await fetch(`${fetchUrl}customer/quotations/get-quotation?quotation_id=${QuoteID}&&package_id=${package_id}&&project_id=${project_id}&&product_category_id=${product_category_id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
        
        const data = await response.json();
        const output = await handleGetResponse(response, data);
        //console.log(output)
        if (output) {
          setQuotation(output); 
          setAmendedDiscount(output.discount || 0);
    
          // Find and set the selected customer based on customer_id
          try {
            const selectedCustomer = customers.find(customer => customer.id === output.customer_id._id);
            setSelectedCustomer(selectedCustomer);
            
            const ProjectIdinQuote = output.project_id._id; 
            console.log(ProjectIdinQuote);
            fetchAllprojectsbyCustomer(selectedCustomer.id, ProjectIdinQuote);
          } catch (error) {
            console.error('Error setting customer or fetching projects:', error);
          }
    
          // Set the selected quote type based on output.quotation_type
          try {
            const selectedQuoteType = quoteTypeOptions.find(option => option.value === output.quotation_type);
            setSelectedQuoteType(selectedQuoteType);
            
            // Optionally trigger row change
            handleQuoteTypeChange(selectedQuoteType);
          } catch (error) {
            console.error('Error setting quote type:', error);
          }
    
          // Set the selected product category based on output.product_category_id._id
          try {
            const selectedProductCategory = categoriesToDisplay.find(category => category._id === output.product_category_id._id);
            const transformedProductCategory = {
              value: selectedProductCategory._id,
              label: selectedProductCategory.product_category_name
            };
            handleProductCategorySelect(transformedProductCategory);
          } catch (error) {
            console.error('Error setting product category:', error);
          }
    
          // Set the selected tax type
          try {
            if (output?.tax_type) {
              setSelectedTax({
                value: output?.tax_type,
                label: output?.tax_type
              });
            }
          } catch (error) {
            console.error('Error setting tax type:', error);
          }
          
        } else {
          handleFetchError(response, attempt, fetchQuotationById);
        }
      } catch (error) {
        handleErrorWithRetry(error, attempt, fetchQuotationById, customers);
      }
    };
    

    const fetchAllprojectsbyCustomer = async (customerid, ProjectId , attempt = 1) => {
      //console.log('Fetching projects for customer_id:', id);
      try {
        const token = sessionStorage.getItem('token');
        const response = await fetch(`${FetchProjectsUrl}/projects/get-projects-by-customer?customer_id=${customerid}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
        const data = await response.json();
        const output = await handleGetResponse(response, data);
        //console.log(output);
        if (output) {
           const formattedProjects = output.map(project => ({
            id: project?._id,  // Use customer ID as value
            label: project?. projectName, // Use customer name as label
            value: project?.projectName
          }));
    
          setProjects(formattedProjects);
          //console.log(formattedProjects)
          const selectedProject = formattedProjects.find(project => project.id === ProjectId);
          //console.log(selectedProject);
          setSelectedProject(selectedProject);
       
        } else {
          if (response.status === 500) {
           // console.log('retry entered');
            setRetryFunction(() => () => fetchAllprojectsbyCustomer(customerid));
          }
          //console.error(data.message);
        }
      } catch (error) {
        console.error('Failed to fetch projects:', error);
  
        if (attempt < RETRY_LIMIT) {
          setRetryCount(attempt + 1);
          setTimeout(() => fetchAllprojectsbyCustomer(customerid, attempt + 1), 1000);
        } else {
          setIsLoading(false);
          setPopupMessage('Internal Server Error. Kindly Retry.');
          setPopupType('500');
          setShowPopup(true);
          setRetryFunction(() => () => fetchAllprojectsbyCustomer(customerid, attempt));
        }
      } finally {
        setIsLoading(false);
      }
    };

    useEffect(() => {
      if (selectedProject) {
        fetchProjectSummarybyProjectId(selectedProject.id);
      }
    }, [selectedProject]); // Fetch summary whenever selectedProject changes

    const fetchProjectSummarybyProjectId = async (projectid) => {
     // console.log(projectid)
      try {
        const token = sessionStorage.getItem('token');
        const response = await fetch(`${FetchProjectsUrl}/summary/get-quotation-project-measurements?projectId=${projectid}&productCategoryId=${selectedProductCategory.value}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
        
        const data = await response.json();
        
        if (response.ok) {
           // console.log(data?.data?.projectMeasurements);
          setAreaMeasurementsData(data);
          setSummary(data);
  
        } else {
          console.error('Failed to fetch projects:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Failed to fetch projects:', error);
      } 
    };
 
   // Centralized error handling
const handleFetchError = (response, attempt, retryFunction) => {
  if (response.status === 500) {
    setRetryFunction(() => retryFunction); 
  }
};
    
    const handleErrorWithRetry = (error, attempt, retryFunction, ...args) => {
      console.error('Failed to fetch:', error);
    
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1);
        setTimeout(() => retryFunction(...args, attempt + 1), 1000);
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => retryFunction(...args, attempt));
      }
    };

    const fetchAttributesByproductCategory = async (product_category, attempt=1)=>{
      try {
        const token = sessionStorage.getItem('token');
        const response = await fetch(`${fetchUrl}product-attributes/get-all-attributes-by-productCategory?product_category_id=${product_category}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
        const data = await response.json();
        const output = await handleGetResponse(response , data)
        //console.log(output)
        if (output) {
        //console.log(output)
         setAttributes(output)
        } else {
          setAttributes([])
          console.error(data.message);
        }
      } catch (error) {
        console.error('Failed to fetch:', error);
  
        if (attempt < RETRY_LIMIT) {
          setRetryCount(attempt + 1); // Increment retry count
          setTimeout(() => fetchAttributesByproductCategory( product_category , attempt + 1), 1000); // Retry after 1 second
        } else {
         
          setPopupMessage('Internal Server Error. Kindly Retry.');
          setPopupType('500');
          setShowPopup(true);
          setRetryFunction(() => () => fetchAttributesByproductCategory(product_category, attempt)); // Set retry function
        }
      }
      }

    const fetchProductsbyProductCategoryID = async (product_category, attempt = 1) => {
      try {
        const token = sessionStorage.getItem('token');
        const userData = JSON.parse(sessionStorage.getItem('userData'));
        const roleId = userData ? userData.roleID : null;
        //console.log(roleId);
        const response = await fetch(`${fetchUrl}product/get-products-by-product-category?product_category_id=${product_category}&roleId=${roleId}&organizationId=${sessionStorage.getItem('organizationId')}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
        //console.log(response)
        const data = await response.json();
        const output = await handleGetResponse(response , data)
       // console.log(output)
        if (output) {
         // console.log(output)
          const productsWithItemName = output.map((product) => {
            // Match the item_id with the rows and get the corresponding item_name
            const matchedRow = rows.find(row => row.item_id === product.item_id);
            const itemName = matchedRow ? product.item_name : ''; // Map the item_name

            return {
                ...product,
                itemName, // Add itemName directly to the product object
            };
        });
       // console.log(output)
        setProducts(output);
         // setProducts(output); // Update productCategories state
        } else {
          setProducts([])
          console.error(data.message);
        }
      } catch (error) {
        console.error('Failed to fetch:', error);
  
        if (attempt < RETRY_LIMIT) {
          setRetryCount(attempt + 1); // Increment retry count
          setTimeout(() => fetchProductsbyProductCategoryID(attempt + 1), 1000); // Retry after 1 second
        } else {
         
          setPopupMessage('Internal Server Error. Kindly Retry.');
          setPopupType('500');
          setShowPopup(true);
          setRetryFunction(() => () => fetchProductsbyProductCategoryID(attempt)); // Set retry function
        }
      }/* finally {
        setIsLoading(false);
      } */
    };

    const handleGetAllUoms = async (attempt = 1) => {
      try {
        const token = sessionStorage.getItem('token');
        const response = await fetch(`${fetchUrl}UOMs/get-all-UOMs`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token,
          },
        });
    
        const data = await response.json();
        const output = await handleGetResponse(response, data);
        if (output) {
          // Log the data to ensure it's fetched correctly
          //console.log('Fetched uoms:',output);
    
          const uomData = output.map((item) => ({
            id: item._id,
            value: item.UOM,
            label: item.UOM,
          }));
    
      setUomOptions(uomData)
        } else {
          console.error('Error:', data.message);
          return ([])
        
         
        }
      }catch (error) {
        console.error('Failed to fetch:', error);
  
        if (attempt < RETRY_LIMIT) {
          setRetryCount(attempt + 1); // Increment retry count
          setTimeout(() => handleGetAllUoms(attempt + 1), 1000); // Retry after 1 second
        } else {
          setIsLoading(false);
          setPopupMessage('Internal Server Error. Kindly Retry.');
          setPopupType('500');
          setShowPopup(true);
          setRetryFunction(() => () => handleGetAllUoms(attempt)); // Set retry function
        }
      }finally {
        setIsLoading(false);
      }
    };

    const fetchAllPriceLists = async (ProductCategory,attempt = 1) => {
     
        try {
          const token = sessionStorage.getItem('token');
          const response = await fetch(fetchUrl + `pricelist/get-pricelists-with-productrates-by-product-category?product_category_id=${ProductCategory.value}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-token': token
            }
          });
          const data = await response.json();
         
          const output = await handleGetResponse(response , data)
          if (output) {
            //console.log(output);
            setPriceLists(output); // Update productCategories state
          } else {
            console.error(data.message);
          }
        } catch (error) {
          console.error('Failed to fetch:', error);
    
          if (attempt < RETRY_LIMIT) {
            setRetryCount(attempt + 1); // Increment retry count
            setTimeout(() => fetchAllPriceLists(ProductCategory, attempt + 1), 1000); // Retry after 1 second
          } else {
           
            setPopupMessage('Internal Server Error. Kindly Retry.');
            setPopupType('500');
            setShowPopup(true);
            setRetryFunction(() => () => fetchAllPriceLists(ProductCategory, attempt)); // Set retry function
          }
        }/* finally {
          setIsLoading(false);
        } */
      
      
    };


    useEffect(() => {
      const fetchQuotationData = async () => {
        try {
          const items = Quotation.items;
          //console.log(items)
        
          const initialRows = items.map((item, index) => {  // Added index here
            const selectedOption = { label: item.tax_type, value: item.tax_type };
                      
            handleTaxChange(
              index,  // Pass the index to the handleTaxChange function
              selectedOption,
              item.tax_type ,
              item?.selling_price,
              item?.quantity
            ); 
            const product = products.find(p => p.item_id === item.item_id) || {};
            const selectedUom = UomOptions.find(p => p?.id === product?.UOM_id) || {};
            let productsForDesignSelection = [];
            if(product.item_group_id === product.item_id){
              productsForDesignSelection = products.filter(p => 
                p.item_group_id === product.item_group_id && 
                p.item_id !== product.item_group_id
              ) || [];
            }else{
             productsForDesignSelection = products.filter(p => p.item_id === product.item_id) || [];
            }
            // Correct calculation for total_area using areaInSft from your data structure
                 const total_area = item.applied_areas.reduce((sum, area) => sum + (parseFloat(area.areaInSft) || 0), 0);

                 // Correct calculation for total_count using asset_count from your data structure
                const total_count = item.applied_areas.reduce((sum, area) => sum + (parseFloat(area.asset_count) || 0), 0);

       
            const commonFields = {
              item_name: product.item_name || '',
              item_id: product.item_id || '',
              item_group_id: product?.item_group_id || '',
              item_group_name: product?.item_group_name || '',
              measured_area: item.measured_area || '',
              quantity: item.quantity || '',
              UOM: selectedUom.value || '',
              UOM_id: selectedUom.id || '',
              price: item.selling_price || '',
              selling_price : product.selling_price || '',
              costPrice: product.cost_price || '',
              cost_price: item.cost_price || '',
              tax: item.tax_rate || '',
              tax_type: item?.tax_type || '',
              total: item.total || '',
              price_list_id: item?.price_list_id || '',
              total_tax_amount: item?.total_tax_amount || 0,
              application_areas : item?.applied_areas || [],
              applied_areas: item?.applied_areas || [],
              sub_items: product?.sub_items || [],
              selectedDesigns: item?.required_order_breakup || [],
              specifications: item?.specifications || [],
              design_products: productsForDesignSelection || [],
              selected_design: item?.selected_design || {},
              total_area: total_area,
              total_count: total_count,
              product_addons : item?.product_addons || []
            };
            //console.log(commonFields)
            
            return commonFields;
          });
        //console.log(initialRows)
          setRows(initialRows); // Set rows state with fetched data
          const TaxOption = { label: Quotation?.tax_prefrence || '', value: Quotation?.tax_prefrence || '' };
          setSelectedTax(TaxOption);
          setTotal(Quotation?.total || 0)
          if (Quotation?.default_price_list_id) {
            const priceList = priceLists.find(p => p?.priceList?._id === Quotation.default_price_list_id)?.priceList;
            if (priceList) {
              const option = { label: priceList.price_list_name, value: Quotation.default_price_list_id };
              setselectedPricList(option);
    
              const allPriceLists = items.map(item => {
                const priceListData = priceLists.find(p => p?.priceList?._id === item.price_list_id)?.priceList;
                if (priceListData) {
                  return { label: priceListData.price_list_name, value: priceListData._id };
                }
                return null; // Handle case where no matching priceList is found
              }).filter(eachList => eachList !== null); // Filter out any null values
    
              setAllRowsSelectedPriceList(allPriceLists);
            }
          }
    
        } catch (error) {
          console.error('Error fetching quotation data:', error);
        }
      };
    
      fetchQuotationData();
      //console.log(products)
    }, [products, UomOptions]);
    
       
  const handleDateChange = (date) => {
    setsalesorderDate(date);
  };

  const handleQuotationNumberChange = (e) => {
    setQuotationNumber(e.target.value);
  };


  const handlePriceListSelect = (option) => {
    setselectedPricList(option);
    setRowPricelists(option)
    const RequiredpriceList= priceLists.find(p=>p?.priceList._id===option?.value)
    setDefaultProductRatesOfPriceList(RequiredpriceList?.productRates )
    if (!selectedPricList) {
      const id = option?.value;
      const RequiredpriceList = priceLists.find(p => p.priceList._id === id);
      const productRates = RequiredpriceList?.productRates;
      
      const updatedRows = [...rows]; // Create a shallow copy of rows array
    
      // Loop through each row and update the price if a matching product rate is found
      rows.forEach((row, index) => {
        const requireproductRate = productRates?.find(p => p.price_list_item_id === row?.item_id);
        
        if (requireproductRate) {
          const custom_price = parseFloat(requireproductRate?.pricing?.custom_rate) || 0;
          const discount = parseFloat(requireproductRate?.pricing?.discount) || 0;
          const discountPrice = (discount / 100) * custom_price;
          const finalPrice = custom_price - discountPrice;
          
          updatedRows[index].price = finalPrice;
          const totaltaxOfproduct = calculateTaxAmount(updatedRows[index].tax || 0 , finalPrice, updatedRows[index].quantity);
          updatedRows[index].total_tax_amount = totaltaxOfproduct;
          updatedRows[index].price_list_id = id;
        }
      });
    
      // Set the updated rows
      setRows(updatedRows);
      
      // Set the allRowsSelectedPriceList with the option for all rows
      const TotalLengthOfItemsInrows = rows.length;
      const allRowsSelectedPriceList = new Array(TotalLengthOfItemsInrows).fill(option);
    
      setAllRowsSelectedPriceList(allRowsSelectedPriceList);
    }
    
  }

  const handleTaxSelect = (option) => {
    setSelectedTax(option);
  };

  const handleQuoteTypeChange = (newQuoteType) => {
    //console.log(newQuoteType)
    setSelectedQuoteType(newQuoteType);
    const newRow = { item_name: '', item_id:'', application_area: {area_name:'',area: '', count:'',}, measured_area: '', quantity: '', UOM: '', price: '', tax: '', total: '', designs: [] };
    setRows([ newRow]);
  };
  
  const handleInputChange = (value, index, key, selling_price) => {
    // console.log(selling_price)
     const updatedData = [...rows];
     
     // Update the specific key in the row data
     updatedData[index][key] = value;
   
     // If the key is 'quantity', calculate the total and update the 'amount' in the same row
     if (key === 'quantity') {
       const total = parseFloat(value) * parseFloat(selling_price);
       //console.log(total)
    
       const totaltaxOfproduct = calculateTaxAmount(updatedData[index]?.tax || 0 , selling_price, value);
       updatedData[index].total_tax_amount = totaltaxOfproduct;
       updatedData[index].total = total;
     }
   
     // Update the rows state
     setRows(updatedData);
   };
  
  
 /*  const handleSelectDesignPopup = (index,) => {
    const selectedRow = rows[index];
    setSelectedItemRow(selectedRow)
    setSelectedItemRowIndex(index)
    //setSubItems(selectedRow?.sub_items); 
    setshowDesignSelectPopup(true);
  };
 */
  const handleClosePopup = () => {
    setshowDesignSelectPopup(false);
  }

  const handleSelectDesign = (design) => {
    const updatedRows = [...rows];
    const selectedDesigns = updatedRows[SelectedItemRowIndex].selectedDesigns || [];
  
    const designIndex = selectedDesigns.findIndex((d) => d.sub_item_id === design.sub_item_id);
  
    if (designIndex !== -1) {
      // Design is already in the array, remove it
      selectedDesigns.splice(designIndex, 1);
    } else {
      // Design is not in the array, add it
      selectedDesigns.push({ ...design, quantity: 1 }); // Default quantity set to 1 when adding
    }
  
    updatedRows[SelectedItemRowIndex].selectedDesigns = [...selectedDesigns];
    setRows(updatedRows); // Trigger a state update
  };
  
  
  const handleQuantityChangeForDesign = (subItemId, index, quantity) => {
    const updatedRows = [...rows];
    const selectedDesigns = updatedRows[SelectedItemRowIndex].selectedDesigns || [];
  
    updatedRows[SelectedItemRowIndex].selectedDesigns = selectedDesigns.map((item) =>
      item.sub_item_id === subItemId ? { ...item, sub_item_quantity: quantity } : item
    );
  
    setRows(updatedRows); // Trigger a state update
  };


  const handleCustomerSelect = (option) => {
    setSelectedProject(null); // Reset the selected project
    setSelectedProjectId(null); // Reset the selected project ID
    setSelectedProductCategory(null); // Reset the selected product category
    setProductCategories([]); 
    fetchProductCategories();
    setSelectedCustomer(option); // Set the selected option object
  };
  
  const handleRowPriceListSelect = (index, option, item) => {
    const id = option?.value;
    const RequiredpriceList = priceLists.find(p => p.priceList._id === id);
    const productRates = RequiredpriceList?.productRates;
    const requireproductRate = productRates?.find(p => p.price_list_item_id === item?.item_id);
  
    const custom_price = parseFloat(requireproductRate?.pricing?.custom_rate) || 0;
    const discount = parseFloat(requireproductRate?.pricing?.discount) || 0;
    const discountPrice = (discount / 100) * custom_price;
    const finalPrice = custom_price - discountPrice;
  
    const updatedRows = [...rows]; // Use spread operator for correct shallow copy of rows array
  
    if (requireproductRate) {
      updatedRows[index].price = finalPrice;
      updatedRows[index].price_list_id = id;
      updatedRows[index].total= updatedRows[index].quantity * finalPrice
      const totaltaxOfproduct = calculateTaxAmount(updatedRows[index].tax || 0 , finalPrice, updatedRows[index].quantity);
          updatedRows[index].total_tax_amount = totaltaxOfproduct;
      setRows(updatedRows);
    }else{
      const itemData = products.find(p=>p.item_id===item?.item_id)
      updatedRows[index].price = itemData?.selling_price;
      updatedRows[index].price_list_id = id;
      const totaltaxOfproduct = calculateTaxAmount(updatedRows[index].tax || 0 , itemData?.selling_price, updatedRows[index].quantity);
          updatedRows[index].total_tax_amount = totaltaxOfproduct;
      setRows(updatedRows);
    }
  
    setAllRowsSelectedPriceList((prev) => {
      const newState = [...prev];
      newState[index] = option;
      return newState;
    });
  };


  const handleProductCategorySelect = (selectedOption) => {
    
    //console.log(selectedOption)
    fetchAllPriceLists(selectedOption);
    setSelectedProductCategory(selectedOption);
    setSelectedProject(null); // Reset the selected project
    setSelectedProjectId(null); // Reset the selected project ID
    fetchProductsbyProductCategoryID(selectedOption.value);
    fetchAttributesByproductCategory(selectedOption.value)
    fetchAllprojectsbyCustomer(selectedCustomer?.id);
    const newRow = { item_name: '', item_id:'', application_area: {area_name:'',area: '', count:'',}, measured_area: '', quantity: '', UOM: '', unit_price: '', tax: '', total: '', designs: [] };
    setRows([newRow]);
    const index = 0
    const option = {label: '' , value: ''}
    handleItemNameChange(index ,option)
  };
  
  const handleProjectSelect = (selectedOption) => {
    setSelectedProject(selectedOption);
    setSelectedProjectId(selectedOption.id);
  };


  const addRow = () => {
    const newRow = { item_name: '', item_id:'', application_area: {area_name:'',area: '', count:'',}, measured_area: '', quantity: '', UOM: '', price: '', tax: '', total: '', sub_items: [] };
    setRows([...rows, newRow]);
    if(selectedPricList){
      setAllRowsSelectedPriceList([...allRowsSelectedPriceList, selectedPricList])
    }
  };

  const deleteRow = (index) => {
    const updatedData = [...rows];
    updatedData.splice(index, 1);
    setRows(updatedData);
    if(selectedPricList){
     const updatedRowPriceLists = [...allRowsSelectedPriceList]
     updatedRowPriceLists.splice(index, 1);
     setAllRowsSelectedPriceList(updatedRowPriceLists)
    }
  };
  
 /*  const handleUomChange = (index, selectedOption) => {
    const value = selectedOption ? selectedOption.value : '';
    const uomid= selectedOption?selectedOption.id:null
      const updatedData = [...rows];
      updatedData[index].UOM = value;
      updatedData[index].UOM_id = uomid;
      //setData(updatedData);
      setRows(updatedData)
  
  }; */

 

    const handleItemNameChange = (index, selectedOption) => {
      //console.log("selected item:",selectedOption)
      const updatedRows = [...rows];
      const selectedItem = products.find(product => product.item_id === selectedOption.value) || null;
      const rowPriceListItem = allRowsSelectedPriceList[index];
      
      // Log the value of the rowPriceListItem for debugging
      //console.log(allRowsSelectedPriceList);
      
      if (selectedItem) {
        updatedRows[index].item_id = selectedItem?.item_id;
        updatedRows[index].item_name = selectedItem?.item_name;
        updatedRows[index].item_image = selectedItem?.item_image;
        updatedRows[index].item_group_name = selectedItem?.item_group_name || '';
        updatedRows[index].item_group_id = selectedItem?.item_group_id || '';
        updatedRows[index].cost_price = selectedItem?.cost_price;
        updatedRows[index].selectedDesigns = [];
        updatedRows[index].specifications = selectedItem?.specifications || [];
        updatedRows[index].selling_price = selectedItem.selling_price;
        updatedRows[index].product_addons = [];
    
        // Check if the item exists in allRowsSelectedPriceList
        if (rowPriceListItem) {
         
         const id = rowPriceListItem?.value
         const RequiredpriceList=  priceLists.find(p=>p.priceList._id=== id)
         const productRates = RequiredpriceList?.productRates
          
          const requireproductRate= productRates.find(p=>p.price_list_item_id===selectedItem?.item_id)
          const custome_price = parseFloat(requireproductRate?.pricing?.custom_rate);
          const discount = parseFloat(requireproductRate?.pricing?.discount) || 0 ;
          const discounPrice = (discount/100) * custome_price
          const finalPrice = custome_price - discounPrice
          if(requireproductRate){
            updatedRows[index].price = finalPrice;
            updatedRows[index].price_list_id =id;
          }else{
            updatedRows[index].price = selectedItem.selling_price;
          }
        
        } else if (selectedItem.selling_price) {
         // console.log('selling price')
          updatedRows[index].price = selectedItem.selling_price;
         
         
        } else{
          console.log('')
        }
    
        const product = products.find(p => p.item_id === selectedItem.item_id);
        const selectedUom = UomOptions.find(p => p?.id === product?.UOM_id);
        
        updatedRows[index].UOM = selectedUom?.value;
        updatedRows[index].UOM_id = selectedUom?.id;
    
        // Apply the selected price to handleInputChange
        //console.log(updatedRows[index].price)
        //handleInputChange(updatedRows[index].price, index, 'price');
            // Store the sub-items in the state
            let productsForDesignSelection = [];
            if(selectedItem.item_group_id === selectedItem.item_id){
              productsForDesignSelection = products.filter(p => 
                p.item_group_id === selectedItem.item_group_id && 
                p.item_id !== selectedItem.item_group_id
              ) || [];
            }else{
             productsForDesignSelection = products.filter(p => p.item_id === selectedItem.item_id) || [];
            }

            setRows((prevRows) => {
              const updatedRows = [...prevRows];
              updatedRows[index].sub_items = selectedItem.sub_items;
              updatedRows[index].design_products = productsForDesignSelection;
              return updatedRows;
            });
       
        
        setRows(updatedRows);
      }
    };


    const handleDesignChange = (index, selectedDesignOption) => {
      try {
        // Validate inputs
        if (index === undefined || index < 0 || index >= rows.length) {
          //console.error("Invalid row index:", index);
          return;
        }
    
        if (!selectedDesignOption || typeof selectedDesignOption !== 'object') {
          console.error("Invalid design option:", selectedDesignOption);
          return;
        }
    
        //console.log("Selected design:", selectedDesignOption);
        
        // Create a safe copy of rows
        const updatedRows = [...rows];
        
        // Find the selected design with null fallback
        const selectedDesign = products.find(design => 
          design && design.item_id === selectedDesignOption.value
        ) || null;
        
        if (!selectedDesign) {
          console.warn("Design not found for value:", selectedDesignOption.value);
          // Still update with empty object to clear any previous selection
          updatedRows[index].selected_design = {};
          setRows(updatedRows);
          return;
        }
        
        // Create design object with safe property access
        const design = {
          design_id: selectedDesign.item_id || '',
          design_name: selectedDesign.item_name || '',
          design_image: selectedDesign.item_image || '',
          design_price: parseFloat(selectedDesign.selling_price) || 0,
          design_cost_price: parseFloat(selectedDesign.cost_price) || 0,
          design_vendor_id: selectedDesign.vendor_id || '',
        };
        
        // Update the row with the design
        updatedRows[index].selected_design = design;
        
        // Update state
        setRows(updatedRows);
      } catch (error) {
        console.error("Error in handleDesignChange:", error);
        // Optionally show user-facing error message
      }
    };
    
    
 
  const handleAreaChange = (index, selectedOptionOrInputValue) => {
    const updatedData = [...rows];
    const oldAreaName = updatedData[index].application_area.area_name;

    if (typeof selectedOptionOrInputValue === 'string') {
      // This handles the case when only the input value changes
      updatedData[index].application_area.area_name = selectedOptionOrInputValue;
    } else {
      // This handles the case when an option is selected
      const value = selectedOptionOrInputValue ? selectedOptionOrInputValue.area : '';
      const areaName = selectedOptionOrInputValue ? selectedOptionOrInputValue.areaName : '';
      const count = selectedOptionOrInputValue ? selectedOptionOrInputValue.count : '';
  
      updatedData[index].application_area.area_name = areaName;
      updatedData[index].application_area.area = value;
      updatedData[index].application_area.count = count;
    }
  
    setRows(updatedData);

    setSelectedApplicationAreas(prevSelected => {
      const newSelected = {...prevSelected};
      if (oldAreaName) delete newSelected[oldAreaName];
      if (selectedOptionOrInputValue && typeof selectedOptionOrInputValue !== 'string') {
        const newAreaName = selectedOptionOrInputValue.areaName;
        newSelected[newAreaName] = true;
  
        const category_mapping_id = parseFloat(categoriesToDisplay.find(p => p._id === selectedProductCategory.value)?.category_mapping_id);
  
        if (category_mapping_id === 3) { // Windows
          if (newAreaName === 'Bedroom Windows Area') {
            Object.keys(newSelected).forEach(key => {
              if (key.startsWith('Bedroom') && key !== 'Bedroom Windows Area') delete newSelected[key];
            });
          } else if (newAreaName === 'Ventilators Area') {
            Object.keys(newSelected).forEach(key => {
              if (key.startsWith('Bathroom') && key !== 'Ventilators Area') delete newSelected[key];
            });
          }
        } else if (category_mapping_id === 2) { // Doors
          if (newAreaName === 'Bedroom Doors Area') {
            Object.keys(newSelected).forEach(key => {
              if (key.startsWith('Bedroom') && key !== 'Bedroom Doors Area') delete newSelected[key];
            });
          } else if (newAreaName === 'Bathroom Doors Area') {
            Object.keys(newSelected).forEach(key => {
              if (key.startsWith('Bathroom') && key !== 'Bathroom Doors Area') delete newSelected[key];
            });
          }
        }else if (category_mapping_id === 1) { // Tiles
          if (newAreaName === 'Balcony Flooring') {
            Object.keys(newSelected).forEach(key => {
              if (key.startsWith('Balcony') && key !== 'Balcony Flooring') delete newSelected[key];
            });
          }
          else if (newAreaName === 'Total Bedrooms Flooring') {
            Object.keys(newSelected).forEach(key => {
              if (key.includes('Bedroom') && key.includes('Flooring') && key !== 'Total Bedrooms Flooring') {
                delete newSelected[key];
              }
            });
          } else if (newAreaName === 'Total Bathrooms Walls') {
            Object.keys(newSelected).forEach(key => {
              if (key.includes('Bathroom') && key.includes('Walls') && key !== 'Total Bathrooms Walls') {
                delete newSelected[key];
              }
            });
          } else if (newAreaName === 'Total Bathrooms Flooring') {
            Object.keys(newSelected).forEach(key => {
              if (key.includes('Bathroom') && key.includes('Flooring') && key !== 'Total Bathrooms Flooring') {
                delete newSelected[key];
              }
            });
          } else if (newAreaName.includes('Bedroom') && newAreaName.includes('Flooring')) {
            delete newSelected['Total Bedrooms Flooring'];
          } else if (newAreaName.includes('Bathroom') && newAreaName.includes('Walls')) {
            delete newSelected['Total Bathrooms Walls'];
          } else if (newAreaName.includes('Bathroom') && newAreaName.includes('Flooring')) {
            delete newSelected['Total Bathrooms Flooring'];
          }
        }
      }
      return newSelected;
    });
    const product = products.find(p => p.item_id === updatedData[index].item_id);
  
    if (selectedQuoteType.value === 'Group') {
      const product_category = categoriesToDisplay.find(p => p._id === selectedProductCategory.value);
      const category_mapping_id = parseFloat(product_category?.category_mapping_id);
  

     if (category_mapping_id === 3 &&
          (updatedData[index].UOM === 'No' || updatedData[index].UOM === 'Nos')) {
        handleInputChange(updatedData[index].application_area.count, index, 'quantity', product?.selling_price);
       // console.log(updatedData[index].quantity);
      }
      else if  (category_mapping_id === 1) {
        const attributeValues = attributes.find(p => p.attribute_name === 'Sq Ft per Box')?.attribute_values;
  
        let conversionFactor = 0;
        if (product && product.attribute_value_ids) {
          for (const id of product.attribute_value_ids) {
            const attributevalue = attributeValues.find(p => p.attribute_value_id === id);
            if (attributevalue) {
              conversionFactor = parseFloat(attributevalue.attribute_value);
              break;
            }
          }
  
          if (conversionFactor > 0) {
            const quantity = Math.ceil((parseFloat(updatedData[index].application_area.area) || 0) / conversionFactor);
            handleInputChange(quantity, index, 'quantity', product?.selling_price);
          } else {
            handleInputChange(updatedData[index].application_area.area, index, 'quantity', product?.selling_price);
          }
        } else {
          handleInputChange(updatedData[index].application_area.area, index, 'quantity', product?.selling_price);
        }
      } else {
        handleInputChange(updatedData[index].application_area.area, index, 'quantity', product?.selling_price);
      }
    }
  };
 
  const handleAreaValueChange = (value, index, key, item_id) => {
    const updatedRows = [...rows];
    const [parentKey, childKey] = key.split('.');
    updatedRows[index][parentKey][childKey] = value;
    setRows(updatedRows);
    const product_category = categoriesToDisplay.find(p => p._id === selectedProductCategory.value);
    const category_mapping_id = parseFloat(product_category?.category_mapping_id);

    const product = products.find(p => p.item_id === item_id);
    if (category_mapping_id === 1) {
      const attributeValues = attributes.find(p => p.attribute_name === 'Sq Ft per Box')?.attribute_values;
     // console.log(attributeValues)
      let conversionFactor = 0;
      if (product && product.attribute_value_ids) {
        for (const id of product.attribute_value_ids) {
          const attributevalue = attributeValues.find(p => p.attribute_value_id === id);
          if (attributevalue) {
            conversionFactor = parseFloat(attributevalue.attribute_value);
            break; // Stop iterating once we find a match
          }
        }

        if (conversionFactor > 0) {
          const quantity = Math.ceil((parseFloat(value) || 0) / conversionFactor);
          //console.log(quantity)
          handleInputChange(quantity, index, 'quantity', product?.selling_price);
        } else {
          handleInputChange(value, index, 'quantity', product?.selling_price);
        }
      } else {
        handleInputChange(value, index, 'quantity', product?.selling_price);
      }
    } else {
      handleInputChange(value, index, 'quantity', product?.selling_price);
    }
  }
  
  const handleAmountInputChange = (e, index, fieldName) => {
    const { value } = e.target;
    
    // Assuming you have a state like `updatedRows` that holds your table data
    const updatedRows = [...rows]; 
  
    updatedRows[index] = {
      ...updatedRows[index],
      [fieldName]: value
    };
  
    // Set the updated rows back to state
    setRows(updatedRows);
    recalculateAmounts();
  };

  const recalculateAmounts = () => {
    const updatedAmounts = rows.map(row => {
      const sellingPrice = products.find(p => p.item_id === row.item_id)?.selling_price || 0;
      return row.quantity * sellingPrice;
    });
  
    setAmounts(updatedAmounts);
  };

  
useEffect(() => {
  if (Quotation && Quotation.discount !== undefined) {
    setDiscountPercentage(Quotation.discount);
  } else {
    setDiscountPercentage(0);
  }

  if (Quotation && Quotation.adjustment !== undefined) {
    setAdjustment(typeof Quotation.adjustment === 'string'
      ? parseFloat(Quotation.adjustment)
      : Quotation.adjustment);
      setAmendedPrice(typeof Quotation.adjustment === 'string'
        ? parseFloat(Quotation.adjustment)
        : Quotation.adjustment);
  } else {
    setAdjustment(0); // Default to 0 if adjustment is not present
  }

  recalculateAmounts();
}, [rows, products]); // Dependencies: rows or products change
  

useEffect(()=>{
  calculateSubtotal()
  calculateTax()
  
   },[rows])
  
   const calculateSubtotal = () => {
    let subtotal = 0;
  
    rows.forEach(row => {
      const quantity = parseFloat(row?.quantity) || 0;
      const price = parseFloat(row?.price) || 0;
      const rowTotal = quantity * price;
      subtotal += rowTotal;
    });
   setSubTotal(subtotal)
    return subtotal;
  };
  
const calculateTotal = () => {
  const subtotal = calculateSubtotal() || 0; // Get the subtotal from the existing function
 // console.log(subtotal)
  const discount = (amendedDiscount / 100) * subtotal || 0; // Calculate the discount based on the amendedDiscount percentage
  const tax_amount = calculateTax() || 0; // Calculate the tax amount using the existing function
 //console.log(tax_amount)
  // Parse amendedPrice to ensure it's a valid number
  const parsedAmendedPrice = parseFloat(amendedPrice) || 0;

  // Adjust the subtotal based on amended price
  const adjustedSubtotal = subtotal - discount + parsedAmendedPrice;

  let total = adjustedSubtotal; // Start with the adjusted subtotal

  if (selectedTax) {
    if (selectedTax.value === 'Tax Exclusive') {
      total += tax_amount; // Add tax if it's exclusive
    }
    // For 'Tax Inclusive', no need to adjust since total is already calculated
  } else {
    // If selectedTax is not defined, assume tax is exclusive
    total += tax_amount;
  }

  return total;
};

useEffect(() => {
  const calculatedTotal = calculateTotal();
  setTotal(calculatedTotal);
}, [rows, amendedDiscount, amendedPrice, selectedTax]);

const calculateTax = () => {
  let TotalTax = 0;
//console.log(rows);
  rows.forEach((p) => {
    const price = parseFloat(p.price) || 0;  // Handle missing or invalid price
    const taxRate = parseFloat(p.tax) || 0;  // Handle missing or invalid tax rate
    const quantity = parseFloat(p.quantity) || 0;  // Handle missing or invalid quantity

    const tax = (taxRate / 100) * price;
    const SubTotalTax = tax * quantity;

    TotalTax += SubTotalTax;
  });
//console.log(TotalTax)
  return TotalTax;
};

const handleTaxChange = (index, selectedOption, value, price, quantity) => {
  if (selectedOption) {
      // Check if all parameters are correct
      //console.log("Parameters:", { index, selectedOption, value, price, quantity });

      // Calculate tax amount
      const totaltaxOfproduct = calculateTaxAmount(value, price, quantity);

      // Log the calculated tax amount to verify it's correct
      //console.log("Calculated Tax Amount:", totaltaxOfproduct);

      // Create a deep copy of rows with the updated tax and total_tax_amount fields
      const updatedRows = rows.map((row, idx) =>
          idx === index
              ? {
                  ...row,
                  tax: value,
                  tax_type: selectedOption?.label,
                  total_tax_amount: totaltaxOfproduct
              }
              : row
      );

      // Log the updated rows to see if the new value is being set correctly
     // console.log("Updated Rows:", updatedRows);

      // Set the updated rows to state
      setRows(updatedRows);

      // Check if the state is being updated correctly
      //console.log("State after update:", updatedRows);
  }
};


  const calculateTaxAmount = (taxRate, price, quantity) => {
    const tax = parseFloat(taxRate) || 0;
    const sellingPricePerQuantity = parseFloat(price) || 0;
    const totalQuantity = parseFloat(quantity) || 0; // Ensure quantity is a number
    const taxAmount = parseFloat(((tax / 100) * sellingPricePerQuantity) * totalQuantity) || 0;
   // console.log(taxAmount)
    return taxAmount;
  };

  const calculateTotalTaxAmount = () => {
   // console.log(rows)
    let totalTaxAmount = 0;
  
    if (Array.isArray(rows)) {
      rows.forEach((row) => {
       // console.log(row)
        totalTaxAmount += row?.total_tax_amount || 0;
      });
    }
   //console.log(totalTaxAmount)
    return totalTaxAmount; // Update the total tax amount state
    
  };
  
  

  const calculateEachProductTotal = (discount, sellingPrice, quantity) => {
    // Ensure sellingPrice and quantity are numbers
    const price = parseFloat(sellingPrice) || 0;
    const qty = parseFloat(quantity) || 0;
    
    // Calculate the initial total without discount
    let total = price * qty;
  
    // If the discount is provided and is a valid number, apply it
    if (discount && !isNaN(discount) && parseFloat(discount) > 0) {
      total = total * (1 - parseFloat(discount) / 100);
    }
    return total;
  };

const handleTheItemsData = () => {
  //console.log(rows)
  const data = rows.map((p) => {
    const application_areasData  = {
      area: p?.total_area || 0,
      count : p?.total_count || 0,
     }
    const itemData = {
      item_name: p?.item_name,
      item_id: p?.item_id,
      quantity: p?.quantity || 0,
      cost_price:  p?.cost_price||0,
      selling_price: p?.price || 0,
      discount: parseFloat(p?.discount) || 0,
      tax_rate: parseFloat(p?.tax) || 0,
      tax_type: p?.tax_type,
      total_tax_amount:p?.total_tax_amount || 0,
      tax_amount: ((parseFloat(p?.price) * parseFloat(p?.tax / 100)) * parseFloat(p?.quantity)) || 0,
      total: calculateEachProductTotal(p?.discount, p?.price, p?.quantity) || 0,
      quantity_breakup: p?.quantity_breakup || {},
      UOM: p?.UOM || '',
      UOM_id: p?.UOM_id,
      application_areas: application_areasData || {},
      applied_areas : p?.application_areas || [],
      specifications: p?.specifications || [], 
    };
   
    if (p.price_list_id) {
      itemData.price_list_id = p.price_list_id;
    }
    if (p.sub_items && 
      p.sub_items.length > 0) {
    
      const subItems = p.selectedDesigns
        .map((item) => {
         
              return {
                sub_item_name: item.sub_item_name,
                sub_item_id: item?.sub_item_id,
                sub_item_quantity: item?.sub_item_quantity,
              };
            
         
        })
    
      itemData.required_order_breakup = subItems;
    }
    

    if (selectedQuoteType?.value === 'Group') {
      itemData.area_types = p?.application_area ;
      //itemData.selected_designs = [...p?.selected_designs];
    }

    return itemData;
  });

  return data;
};

const handleSaveQuotationData = async () => {
  
  try {
    const formattedDate = new Date(quotationDate).toISOString();

    const quotation = {
      customer_id: selectedCustomer?.id || '',
      product_category_id: selectedProductCategory?.value || '',
      quotation_number : Quotation?.quotation_number || '',
      quotation_date: formattedDate,
      salesorder_date: salesorderDate || '',
      subtotal: await calculateSubtotal() || 0,
      tax_amount: await calculateTax() || 0,
      discount: amendedDiscount || 0,
      adjustment: amendedPrice || 0,
      terms_and_conditions: '', // Add actual terms and conditions if needed
      total: await calculateTotal() || 0,
      tax_prefrence:selectedTax?.label || '',
      organizationId:sessionStorage.getItem('organizationId'),
      quotation_type:Quotation?.quotation_type
    };
    if (selectedProject?.id) {
      quotation.project_id = selectedProject.id;
    }
    if (selectedPricList) {
      quotation.default_price_list_id = selectedPricList.value;
    }

    const ItemsData = await handleTheItemsData();

    const token = sessionStorage.getItem('token');
    const requestBody = {
      ...quotation,
      items: ItemsData
    };


    const response = await fetch(`${fetchUrl}customer/quotations/save-quotation`, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify(requestBody)
    });
    const data = await response.json()
    const output = await handleSaveResponse(response,data)
    if (output) {
      setPopupMessage('Quotation updated successfully');
      setPopupType('200or201');
      setShowPopup(true);
      setTimeout(() => {
        navigate('/bb/app/sales/quotelists');
      }, 2000);   
    }
    } catch (error) {
    console.error('Failed to save quotation data:', error);
    // Handle the error (e.g., show an error message to the user)
  }
};

/* const handleAreaValueChange = (value, index, key) => {
  console.log(value, index, key);
  if (key === 'application_area.area') {
    rows[index].application_area.area = value;
  }
} */



  const closePopup = () => {
    //console.log("closePopup called");
    setShowPopup(false);
  };
  
  const Retry = async() => {
    //console.log("Retry called");
    setTimeout(async ()=>{
      if(retryFunction){

        await retryFunction ();
      }

      setIsLoading(false)
    },1000)
    
    setShowPopup(false);
  };
  
  const BackToLoginPage = () => {
    //console.log("Back To Login Page");
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
  };

  const handleStayHere = () => {
    setShowCancelPopup(false);
  }

  const handleCancel = () => {
    setShowCancelPopup(true);
  }

  const handleLeave = () => {
    navigate(-1);
  }

  const handleSaveSpecifications = () => {
    // Add your save logic here
    const updatedSpecs = selectedSpecifications.map(spec => ({
      [spec.name]: spec.value
    }));
  
    const updatedRows = [...rows];
    updatedRows[selectedItemIndex].specifications = JSON.stringify(updatedSpecs);
    setRows(updatedRows);
    setShowSpecificationsPopup(false);
    };

    const handleOpenSpecification = (item, index) => {
      if (item?.specifications) {
        try {
          const specs = typeof item.specifications === 'string' 
            ? JSON.parse(item.specifications)
            : item.specifications;
            
          // Format specifications same way as they appear in the table cell
          const formattedSpecs = specs.map((spec, idx) => {
            const entries = Object.entries(spec);
            return {
              id: idx + 1,
              name: entries[0][0],
              value: entries[0][1]
            };
          });
    
          setSelectedSpecifications(formattedSpecs);
          setSelectedItemIndex(index);
          setShowSpecificationsPopup(true);
        } catch (error) {
          console.log("Error parsing specifications:", error);
        }
      }
    };
    
      
  const addSpecificationRow = () => {
    const newSpec = {
      id: (selectedSpecifications?.length || 0) + 1,
      name: '',
      value: ''
    };
    setSelectedSpecifications([...(selectedSpecifications || []), newSpec]);
  };
  
  const deleteSpecificationRow = (index) => {
    const updatedSpecs = selectedSpecifications.filter((_, idx) => idx !== index);
    // Update IDs after deletion
    const reorderedSpecs = updatedSpecs.map((spec, idx) => ({
      ...spec,
      id: idx + 1
    }));
    setSelectedSpecifications(reorderedSpecs);
  };

  const formatNumber = (value) => {
    const parsedValue = parseFloat(value);
    if (Number.isFinite(parsedValue)) {
      const roundedValue = (Math.round(parsedValue * 100) / 100);
      return roundedValue.toLocaleString('hi-IN', { minimumFractionDigits: 2 }); 
    }
    return '0.00';
  };

 /*  const handleMultipleAreaSelection = (rowIndex, selectedArea) => {
    const updatedRows = [...rows];
    
    // Initialize application_areas array if it doesn't exist
    if (!updatedRows[rowIndex].application_areas) {
      updatedRows[rowIndex].application_areas = [];
    }
   
    // Check if the area is already selected
    const existingAreaIndex = updatedRows[rowIndex].application_areas.findIndex(
      area => area.area_name === selectedArea.areaName
    );
    
    if (existingAreaIndex >= 0) {
      // If already selected, remove it
      updatedRows[rowIndex].application_areas.splice(existingAreaIndex, 1);
    } else {
      // If not selected, add it
      updatedRows[rowIndex].application_areas.push({
        area_name: selectedArea?.areaName || '',
        areaInSft: selectedArea?.area || '',
        asset_count: selectedArea.count || '',
        asset_name : selectedArea.asset_name,
        room_name : selectedArea.room_name,
        height : selectedArea.height,
        width : selectedArea.width,
        unit : selectedArea.unit,
        count: selectedArea.count,
      });
    }
    
    // Update the application_area field for backward compatibility
    if (updatedRows[rowIndex].application_areas.length > 0) {
      const firstArea = updatedRows[rowIndex].application_areas[0];
      updatedRows[rowIndex].application_area = {
        area_name: firstArea.areaName,
        areaInSft: firstArea?.area || '',
        area: firstArea.area,
        count: firstArea.count,
        asset_name : firstArea.asset_name,
        asset_count : firstArea.count,
        room_name : firstArea.room_name,
        height : firstArea.height,
        width : firstArea.width,
        unit : firstArea.unit

      };
    } else {
      updatedRows[rowIndex].application_area = { area_name: '', area: '', count: '', areaInSft: '', asset_name : '', asset_name : '',  asset_count : '',  room_name : '', height : '', width : '', unit : '' };
    }
    
    // Get product and category information
    const product = products.find(p => p.item_id === updatedRows[rowIndex].item_id);
    const product_category = categoriesToDisplay.find(p => p._id === selectedProductCategory.value);
    const category_mapping_id = parseFloat(product_category?.category_mapping_id);
    
    // Calculate total area and count based on product category
    let totalArea = 0;
    let totalCount = 0;
    
    // Aggregate areas and counts from all selected areas
    updatedRows[rowIndex].application_areas.forEach(area => {
      if (category_mapping_id === 1) { // Tiles
        // For tiles, sum up the areas
        totalArea += parseFloat(area.areaInSft) || 0;
      } else if (category_mapping_id === 2 || category_mapping_id === 3) { // Doors or Windows
        // For doors and windows, sum up the counts
        totalCount += parseFloat(area.asset_count) || 0;
        // Also track area for cases where we need it
        totalArea += parseFloat(area.areaInSft) || 0;
      } else {
        // For other categories, sum both
        totalArea += parseFloat(area.areaInSft) || 0;
        totalCount += parseFloat(area.asset_count) || 0;
      }
    });
    
    // Store the aggregated values for reference
    updatedRows[rowIndex].total_area = totalArea;
    updatedRows[rowIndex].total_count = totalCount;
    
    // Update quantity based on product category and UOM
    if (category_mapping_id === 3 && 
        (updatedRows[rowIndex].UOM === 'No' || updatedRows[rowIndex].UOM === 'Nos')) {
      // For Windows with UOM as No or Nos, use count
      handleInputChange(totalCount, rowIndex, 'quantity', updatedRows[rowIndex].price);
    } else if (category_mapping_id === 1) { // Tiles
      // For Tiles, apply conversion factor if available
      const attributeValues = attributes.find(p => 
        p.attribute_name.toLowerCase() === 'sq ft per box')?.attribute_values;
      
      let conversionFactor = 0;
      
      if (product && product.attribute_value_ids) {
        for (const id of product.attribute_value_ids) {
          const attributevalue = attributeValues?.find(p => p.attribute_value_id === id);
          if (attributevalue) {
            conversionFactor = parseFloat(attributevalue.attribute_value);
            break;
          }
        }
        
        if (conversionFactor > 0) {
          // Calculate boxes needed based on total area and conversion factor
          const quantity = Math.ceil(totalArea / conversionFactor);
          handleInputChange(quantity, rowIndex, 'quantity', product?.selling_price);
          
          // Store the conversion factor and boxes calculation for reference
          updatedRows[rowIndex].conversion_factor = conversionFactor;
          updatedRows[rowIndex].boxes_needed = quantity;
        } else {
          // If no conversion factor, use the total area as quantity
          handleInputChange(totalArea, rowIndex, 'quantity', product?.selling_price);
        }
      } else {
        // If no attribute values, use the total area as quantity
        handleInputChange(totalArea, rowIndex, 'quantity', product?.selling_price);
      }
    } else if (category_mapping_id === 2) { // Doors
      // For Doors, typically use count
      if (updatedRows[rowIndex].UOM === 'No' || updatedRows[rowIndex].UOM === 'Nos') {
        handleInputChange(totalCount, rowIndex, 'quantity', product?.selling_price);
      } else {
        // If UOM is not count-based, use area
        handleInputChange(totalArea, rowIndex, 'quantity', product?.selling_price);
      }
    } else {
      // For other categories, default to area-based calculation
      handleInputChange(totalArea, rowIndex, 'quantity', product?.selling_price);
    }
    
    // Create a breakdown of areas for the item
    updatedRows[rowIndex].area_breakdown = updatedRows[rowIndex].application_areas.map(area => ({
      name: area.areaName,
      area: parseFloat(area.area) || 0,
      areaInSft: parseFloat(area.areaInSft) || 0,
      count: parseFloat(area.count) || 0,
      asset_count : parseFloat(area.asset_count) || 0,
    }));
    
    setRows(updatedRows);
  }; */

  const handleMultipleAreaSelection = (rowIndex, selectedArea) => {
    const updatedRows = [...rows];
    
    // Initialize application_areas array if it doesn't exist
    if (!updatedRows[rowIndex].application_areas) {
      updatedRows[rowIndex].application_areas = [];
    }
    
    // Get product category information
    const product_category = categoriesToDisplay.find(p => p._id === selectedProductCategory.value);
    const category_mapping_id = parseFloat(product_category?.category_mapping_id);
    
    // Check if the area is already selected based on product category
    let existingAreaIndex = -1;
    
    if (category_mapping_id === 1) { // Tiles
      // For tiles, use area_name
      existingAreaIndex = updatedRows[rowIndex].application_areas.findIndex(
        area => area.area_name === selectedArea.areaName
      );
    } else if (category_mapping_id === 2 || category_mapping_id === 3) { // Doors or Windows
      // For doors and windows, use asset_name if available
      if (selectedArea.asset_name) {
        existingAreaIndex = updatedRows[rowIndex].application_areas.findIndex(
          area => area.asset_name === selectedArea.asset_name
        );
      } else {
        // Fallback to area_name if asset_name is not available
        existingAreaIndex = updatedRows[rowIndex].application_areas.findIndex(
          area => area.area_name === selectedArea.areaName
        );
      }
    } else {
      // For other categories, check both
      existingAreaIndex = updatedRows[rowIndex].application_areas.findIndex(
        area => area.area_name === selectedArea.areaName || 
               (area.asset_name && selectedArea.asset_name && area.asset_name === selectedArea.asset_name)
      );
    }
    
    if (existingAreaIndex >= 0) {
      // If already selected, remove it
      updatedRows[rowIndex].application_areas.splice(existingAreaIndex, 1);
    } else {
      // If not selected, add it
      updatedRows[rowIndex].application_areas.push({
        area_name: selectedArea.areaName || '',
        areaInSft: selectedArea.area || '',
        asset_count: selectedArea.count || '',
        asset_name: selectedArea.asset_name || '',
        room_name: selectedArea.room_name || '',
        height: selectedArea.height || '',
        width: selectedArea.width || '',
        unit: selectedArea.unit || '',
        count: selectedArea.count || '',
      });
    }
    
    // Update the application_area field for backward compatibility
    if (updatedRows[rowIndex].application_areas.length > 0) {
      const firstArea = updatedRows[rowIndex].application_areas[0];
      updatedRows[rowIndex].application_area = {
        area_name: firstArea.area_name,
        areaInSft: firstArea.areaInSft || '',
        area: firstArea.areaInSft || firstArea.area || '',
        count: firstArea.count || '',
        asset_name: firstArea.asset_name || '',
        asset_count: firstArea.asset_count || firstArea.count || '',
        room_name: firstArea.room_name || '',
        height: firstArea.height || '',
        width: firstArea.width || '',
        unit: firstArea.unit || ''
      };
    } else {
      updatedRows[rowIndex].application_area = {
        area_name: '',
        area: '',
        count: '',
        areaInSft: '',
        asset_name: '',
        asset_count: '',
        room_name: '',
        height: '',
        width: '',
        unit: ''
      };
    }
    
    // Get product information
    const product = products.find(p => p.item_id === updatedRows[rowIndex].item_id);
    
    // Calculate total area and count based on product category
    let totalArea = 0;
    let totalCount = 0;
    
    // Aggregate areas and counts from all selected areas
    updatedRows[rowIndex].application_areas.forEach(area => {
      if (category_mapping_id === 1) { // Tiles
        // For tiles, sum up the areas
        totalArea += parseFloat(area.areaInSft) || 0;
      } else if (category_mapping_id === 2 || category_mapping_id === 3) { // Doors or Windows
        // For doors and windows, sum up the counts
        totalCount += parseFloat(area.asset_count) || 0;
        // Also track area for cases where we need it
        totalArea += parseFloat(area.areaInSft) || 0;
      } else {
        // For other categories, sum both
        totalArea += parseFloat(area.areaInSft) || 0;
        totalCount += parseFloat(area.asset_count) || 0;
      }
    });
    
    // Store the aggregated values for reference
    updatedRows[rowIndex].total_area = totalArea;
    updatedRows[rowIndex].total_count = totalCount;
    
    // Update quantity based on product category and UOM
    if (category_mapping_id === 3 && 
        (updatedRows[rowIndex].UOM === 'No' || updatedRows[rowIndex].UOM === 'Nos')) {
      // For Windows with UOM as No or Nos, use count
      handleInputChange(totalCount, rowIndex, 'quantity', updatedRows[rowIndex].price);
    } else if (category_mapping_id === 1) { // Tiles
      // For Tiles, apply conversion factor if available
      const attributeValues = attributes.find(p => 
        p.attribute_name.toLowerCase() === 'sq ft per box')?.attribute_values;
      
      let conversionFactor = 0;
      
      if (product && product.attribute_value_ids) {
        for (const id of product.attribute_value_ids) {
          const attributevalue = attributeValues?.find(p => p.attribute_value_id === id);
          if (attributevalue) {
            conversionFactor = parseFloat(attributevalue.attribute_value);
            break;
          }
        }
        
        if (conversionFactor > 0) {
          // Calculate boxes needed based on total area and conversion factor
          const quantity = Math.ceil(totalArea / conversionFactor);
          handleInputChange(quantity, rowIndex, 'quantity', product?.selling_price);
          
          // Store the conversion factor and boxes calculation for reference
          updatedRows[rowIndex].conversion_factor = conversionFactor;
          updatedRows[rowIndex].boxes_needed = quantity;
        } else {
          // If no conversion factor, use the total area as quantity
          handleInputChange(totalArea, rowIndex, 'quantity', product?.selling_price);
        }
      } else {
        // If no attribute values, use the total area as quantity
        handleInputChange(totalArea, rowIndex, 'quantity', product?.selling_price);
      }
    } else if (category_mapping_id === 2) { // Doors
      // For Doors, typically use count
      if (updatedRows[rowIndex].UOM === 'No' || updatedRows[rowIndex].UOM === 'Nos') {
        handleInputChange(totalCount, rowIndex, 'quantity', product?.selling_price);
      } else {
        // If UOM is not count-based, use area
        handleInputChange(totalArea, rowIndex, 'quantity', product?.selling_price);
      }
    } else {
      // For other categories, default to area-based calculation
      handleInputChange(totalArea, rowIndex, 'quantity', product?.selling_price);
    }
    
    // Create a breakdown of areas for the item
    updatedRows[rowIndex].area_breakdown = updatedRows[rowIndex].application_areas.map(area => ({
      name: area.area_name,
      area: parseFloat(area.area) || 0,
      areaInSft: parseFloat(area.areaInSft) || 0,
      count: parseFloat(area.count) || 0,
      asset_count: parseFloat(area.asset_count) || 0,
    }));
    
    setRows(updatedRows);
  };
 
  const handleShowAreaBreakdown = (index) => {
    setShowBreakdownForIndex(index);
  };

  const handleCloseBreakdown = () => {
    setShowBreakdownForIndex(null);
  };
  

  const handleUpdateDesigns = async (breakdownForIndex) => {
    try {
      setIsSaving(true); // Show loading state
      
      const data = {
        quotationId: Quotation._id,
        applied_areas: rows[breakdownForIndex].application_areas,
        item_id: rows[breakdownForIndex].item_id,
      };
      
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${fetchUrl}customer/quotations/update-applied-areas`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify(data)
      });
      
      const responseData = await response.json();
      
      if (response.ok) {
        // Handle successful update
        setPopupMessage('Designs updated successfully');
        setPopupType('200or201');
        setShowPopup(true);
        setHasUnsavedChanges(false);
        
        // Update the main quotation data to reflect the changes
        const updatedQuotation = { ...Quotation };
        const itemIndex = updatedQuotation.items.findIndex(item => item.item_id === data.item_id);
        
        if (itemIndex !== -1) {
          updatedQuotation.items[itemIndex].application_areas = data.application_areas;
          setQuotation(updatedQuotation);
        }
        
        setTimeout(() => {
          handleCloseBreakdown();
          //setShowPopup(false)
        }, 500);
        setTimeout(() => {
          
          setShowPopup(false)
        }, 2000);
      } else {
        // Handle error response
        setPopupMessage(responseData.message || 'Failed to update designs');
        setPopupType('400');
        setShowPopup(true);
      }
    } catch (error) {
      console.error("Error updating designs:", error);
      setPopupMessage('An error occurred while updating designs');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => handleUpdateDesigns(breakdownForIndex));
    } finally {
      setIsSaving(false);
    }
  };

  const FetchAddonProducts = async (main_product_group_id) => {
    console.log('entered into FetchAddonProducts');
    try {
      const response = await fetch(`${fetchUrl}product-groups/get-addon-products?product_group_id=${main_product_group_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': localStorage.getItem('token')
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log(data);
      return data;
    } catch (error) {
      console.error('Error fetching addon products:', error);
      return { success: false, data: [] };
    }
  };
  
  const handleApplySelectedAddons = () => {
    if (showAddonSelectionForIndex === null) return;
    
    // Get all addon products from all subcategories
    const allAddons = Object.values(subcategoryAddons)
      .flatMap(subcategory => subcategory.products);
    
    // Filter to only the selected addons
    const selectedAddonProducts = allAddons.filter(addon =>
      selectedAddons.includes(addon.item_id)
    );
    
    // Format addons for the item
    const formattedAddons = selectedAddonProducts.map(addon => ({
      item_id: addon.item_id,
      item_name: addon.item_name,
      item_group_id: addon.item_group_id,
      item_group_name: addon.item_group_name,
      selling_price: addon.selling_price || 0,
      cost_price: addon.cost_price || 0,
      quantity: 1,
      UOM: addon.UOM || 'Nos',
      UOM_id: addon.UOM_id || '',
      tax_rate: addon.GST || 0,
      vendor_id: addon.vendor_id || '',
      vendor_name: addon.vendor_name || '',
      product_sub_category_id: addon.product_sub_category_id || ''
    }));
    
    // Update the rows array
    const updatedRows = [...rows];
    const currentRow = updatedRows[showAddonSelectionForIndex];
    console.log('currentRow', currentRow)
    // Store the original prices if not already stored
    const originalSellingPrice = currentRow.sellig_price || parseFloat(currentRow.selling_price) || 0;
    const originalCostPrice = currentRow.costPrice || parseFloat(currentRow.cost_price) || 0;
    
    // Calculate the total addon selling price and cost price
    const addonSellingPriceTotal = formattedAddons.reduce((sum, addon) => 
      sum + (parseFloat(addon.selling_price) || 0), 0);
    
    const addonCostPriceTotal = formattedAddons.reduce((sum, addon) => 
      sum + (parseFloat(addon.cost_price) || 0), 0);
    
    // Calculate the new selling price and cost price with addons
    const newSellingPrice = originalSellingPrice + addonSellingPriceTotal;
    console.log('addonSellingPriceTotal:', newSellingPrice);
    const newCostPrice = originalCostPrice + addonCostPriceTotal;
    
    // Get the quantity
    const quantity = parseFloat(currentRow.quantity) || 1;
    
    // Calculate the new item total (price * quantity)
    const newItemTotal = newSellingPrice * quantity;
    
    // Calculate GST amount
    const taxRate = parseFloat(currentRow.tax_rate) || 0;
    const newGstAmount = (newItemTotal * taxRate) / 100;
    
    // Calculate the total with GST
    const newTotalWithGst = newItemTotal + newGstAmount;
    
    // Update the row with new values
    updatedRows[showAddonSelectionForIndex] = {
      ...currentRow,
      product_addons: formattedAddons,
      // Store original values
      price: newSellingPrice,
      cost_price: newCostPrice,
      item_total: newItemTotal,
      gst_amount: newGstAmount,
      total: newTotalWithGst,
    };
    
    // Update state
    setRows(updatedRows);
    
    // Close the modal and reset selection state
    setShowAddonSelectionForIndex(null);
    setSelectedAddons([])
  };

  const handleShowAddonsSelection = async (index) => {
    setShowAddonSelectionForIndex(index);
    setIsLoadingAddons(true);
    
    // Initialize selected addons from current item's addons
    const currentAddons = rows[index]?.product_addons || [];
    setSelectedAddons(currentAddons.map(addon => addon.item_id));
    
    try {
      // Get the product group ID for the current item
      const productGroupId = rows[index]?.item_group_id;
      console.log('productGroupId', productGroupId);
      
      if (!productGroupId) {
        setSubcategoryAddons({});
        setIsLoadingAddons(false);
        console.error("No product group ID found for this item");
        return;
      }
      
      // Fetch all addon products with the existing FetchAddonProducts function
      const addonProductsResponse = await FetchAddonProducts(productGroupId);
      
      if (!addonProductsResponse.success || !addonProductsResponse.data || addonProductsResponse.data.length === 0) {
        setSubcategoryAddons({});
        setIsLoadingAddons(false);
        console.info("No addon products available for this item");
        return;
      }
      
      // The response contains subcategories with their products and vendors
      const subcategories = addonProductsResponse.data;
      
      // Create a map of subcategory data
      const subcategoryMap = {};
      
      // Process each subcategory
      subcategories.forEach(subcategory => {
        subcategoryMap[subcategory.subcategory_id] = {
          name: subcategory.subcategory_name,
          products: subcategory.products || [],
          vendors: subcategory.vendors || []
        };
      });
      
      // Set the subcategory data
      setSubcategoryAddons(subcategoryMap);
      
      setIsLoadingAddons(false);
    } catch (error) {
      console.error('Error fetching addons:', error);
      setSubcategoryAddons({});
      setIsLoadingAddons(false);
    }
  };
  
  
  
  // Function to handle vendor filter change
  const handleVendorFilterChange = (vendorId) => {
    setSelectedVendor(vendorId || null);
    
    // If no vendor is selected, show all addons
    if (!vendorId) {
      setFilteredSubcategoryAddons(subcategoryAddons);
      return;
    }
    
    // Filter addons by the selected vendor
    const filtered = {};
    
    Object.entries(subcategoryAddons).forEach(([subcategoryId, subcategory]) => {
      // Filter products to only include those from the selected vendor
      const filteredProducts = subcategory.products.filter(
        product => product.vendor_id === vendorId
      );
      
      if (filteredProducts.length > 0) {
        filtered[subcategoryId] = {
          ...subcategory,
          products: filteredProducts
        };
      }
    });
    
    setFilteredSubcategoryAddons(filtered);
  };
  
  useEffect(() => {
    if (Object.keys(subcategoryAddons).length === 0) {
      setFilteredSubcategoryAddons({});
      return;
    }
    
    if (!selectedVendor) {
      setFilteredSubcategoryAddons(subcategoryAddons);
      return;
    }
    
    handleVendorFilterChange(selectedVendor);
  }, [selectedVendor, subcategoryAddons]);
  

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="bg-white flex flex-row w-full justify-left h-full overflow-y-hidden">
      <div className="flex flex-row w-full">
        <div className="w-full flex-1">
          <div className="flex flex-col w-full h-full justify-center items-center">
            <div className="w-full h-full flex flex-col justify-between">
              <div className="w-full h-16 border-b flex items-center">
                <div className="flex w-full justify-between px-4 items-center">
                  <h1 className="text-lg font-semibold">Edit Quote</h1>
                </div>
              </div>
              <div className="flex flex-col justify-start items-start w-full flex-grow h-80 overflow-y-auto">
                <div className="w-full flex flex-col justify-start items-start px-4 bg-[#F9F9FB]">
                  <div className='w-full flex flex-row'>
                    <div className="flex flex-col w-full">
                      <div className="w-full flex flex-row items-center mb-4 mt-5 space-x-2">
                        <label htmlFor="customername" className="block text-sm font-regular text-[#e54643] w-1/6">
                          Customer Name<span className="text-red-500">*</span>
                        </label>
                        <div className='w-1/3'>
                            <input
                              type="text"
                              className="w-full outline-none block rounded-md border border-gray-300 p-2 text-sm text-gray-700"
                              value={selectedCustomer?.label || ''}
                              readOnly
                              disabled
                            />
                          </div>

                      </div>
                      <div className="w-full flex flex-row items-center mb-4 mt-5 space-x-2">
                        <label htmlFor="customername" className="block text-sm font-regular text-gray-700 w-1/6">
                         Quotation Type{/* <span className="text-red-500">*</span> */}
                        </label>
                      {/*   <div className='w-1/3'> */}
                        {/* <CustomDropdown
            options={quoteTypeOptions}
            selected={selectedQuoteType}
            onSelect={handleQuoteTypeChange}
           placeholder='Select Sales Order Type'
            showAddNew={false}
            showSearch={false} // Disable search for Quote Type
          /> */}
        <input
                        type="text"
                        className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                        value={selectedQuoteType?.value}
                        onChange={handleQuoteTypeChange}
                        disabled
                      />
                        {/* </div> */}
                      </div>
                    </div>
                  </div>
                  </div>
                  <div className="w-full flex flex-col justify-start items-start px-4">
                  <div className='w-full flex flex-row'>
                  <div className="flex flex-col w-full">
                     <div className="w-full flex flex-row items-center mb-4 mt-5 space-x-2">
                      <label htmlFor="productSubCategoryName" className="block text-sm font-regular text-gray-700 w-1/6">
                        Quote Number
                      </label>
                      <input
                        type="text"
                        className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                        value={Quotation?.quotation_number}
                        onChange={handleQuotationNumberChange}
                      />
                    </div> 
                    <div className="w-full flex flex-row items-center mb-4 mt-5 space-x-2">
                      <label htmlFor="salesorderDate" className="block text-sm font-regular text-[#e54643] w-1/6">
                        quotation Date<span className="text-red-500">*</span>
                      </label>
                      <DatePicker
                        selected={quotationDate}
                        onChange={(date) => setQuotationDate(date)}                        
                        dateFormat="dd/MM/yyyy"
                        className="w-full outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                      />
                    </div>
                    <div className=" w-full flex flex-row items-center mb-4 mt-5 space-x-2">
                <label htmlFor="productCategoryName" className="block text-sm font-regular text-[#e54643] w-1/6">
                  Item Category<span className="text-red-500">*</span>
                </label>           
                   {/*  <div className='w-1/3'> */}
                   
                    <input
                        type="text"
                        className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                        value={selectedProductCategory?.label}
                        onChange={handleQuoteTypeChange}
                        disabled
                      />
                   {/*  </div> */}
                    
              </div>
              
              <div className=" w-full flex flex-row items-center mb-4 mt-5 space-x-2">
                <label htmlFor="productCategoryName" className="block text-sm font-regular text-gray-700 w-1/6">
                 Project
                </label> 
                <div className='w-1/3'>          
                <CustomDropdown
            options={projects}
            selected={selectedProject}
            onSelect={handleProjectSelect}
            placeholder="Select Project"
            showAddNew={false}
            showSearch={true}
          />
         </div>
              </div>
                  </div>
                </div>
                <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
              </div>
              <div className="w-full flex flex-col justify-start items-start px-4">
                  <div className='w-full flex flex-row'>
                  <div className="flex flex-col w-full">
              <div className=" w-full flex flex-row items-center mb-4 mt-5 space-x-2">
              <div className='w-1/6'>
              <CustomDropdown
        options={TaxOptions}
        selected={selectedTax}
        onSelect={handleTaxSelect}
        showAddNew={false}
        placeholder='Item Tax Prefrence'
        showSearch={false}
      />          
                </div>
                <div className='w-1/6'>
              <CustomDropdown
         options={priceLists.map(priceList => ({
          value: priceList?.priceList._id,
          label:  priceList?.priceList.price_list_name
        }))}
        selected={selectedPricList}
        onSelect={handlePriceListSelect}
        showAddNew={false}
        placeholder='Select Price List'
        showSearch={true}
      />          
                </div>
              </div>

              <div className="w-full container mx-auto px-4 mb-2 mt-4">
  <div className='border border-gray-300 rounded-md bg-[#fafafc]'>
  <h2 className="text-lg font-semibold py-1 px-2">Item Table</h2>
  </div>
  <table className="w-full">
        <thead>
          <tr className="font-semibold">
            <th className="font-semibold border-r border-b text-left text-sm py-2 px-2 w-1/5">Item Details</th>
            <th className="font-semibold border-r border-b text-left text-sm py-2 px-2 w-1/7">Item Group</th>
            <th className="font-semibold border-r border-b text-left text-sm py-2 px-2 w-1/10">Specifications</th>

            {selectedQuoteType?.value === 'Group' && (
          <>
            {(selectedProductCategory?.label === 'Tiles' ||
              selectedProductCategory?.label === 'Doors' ||
              selectedProductCategory?.label === 'Windows') && (
              <>
                <th className="font-semibold border-r border-b text-left text-sm py-2 px-2 w-1/7">Application Area</th>
                <th className="font-semibold border-r border-b text-left text-sm py-2 px-2">
                  {selectedProductCategory?.label === 'Tiles'
                    ? 'Tiles Area'
                    : `${selectedProductCategory?.label} Count`}
                </th>
              </>
            )}
          </>
        )}
            <th className="font-semibold border-r border-b text-left text-sm py-2 px-2">Quantity</th>
            <th className="font-semibold border-r border-b text-left text-sm py-2 px-2">UOM</th>
            <th className="font-semibold border-r border-b text-left text-sm py-2 px-2">Price</th>
            <th className="font-semibold border-r border-b text-left text-sm py-2 px-2">Tax</th>
            <th className="font-semibold border-b  border-r text-left text-sm py-2 px-2">Amount</th>
            {selectedQuoteType?.value === 'Group' && (
          <>
            {(selectedProductCategory?.label === 'Tiles' ||
              selectedProductCategory?.label === 'Doors' ||
              selectedProductCategory?.label === 'Windows') && (
              <>
                 <th className="font-semibold text-left border-b text-sm py-2 px-2"></th>
              </>
            )}
          </>
        )}
           
            
          </tr>
        </thead>
        <tbody>
        {rows.map((item, index) => (
        //  console.log(item),
  <tr key={index}>
    <td className="border-r border-b px-2 py-2" ref={dropdownRef}>
          <TableSearchDropDown
        options={products.map(product => ({
          value: product.item_id,
          label: product.item_name,
        }))} // Map item_name options
        value={item.item_name} // Set the default selected value
        onChange={(selectedOption) => handleItemNameChange(index, selectedOption)} // Handle item_name change
      />
    </td>

   
    {/* <td className="border-r border-b px-1 py-2" >
        <p>{item?.item_group_name || ''}</p> 
    </td> */}

    <td className="border-r border-b p-2">
            <div className="flex justify-between items-center">
              <p className="text-sm truncate max-w-[120px]">{item?.item_group_name || '-'}
              
              </p>
              {selectedProductCategory?.label.toLowerCase() === 'doors' && (
                 <button 
                 className="ml-2 p-1 text-blue-500 hover:bg-blue-50 rounded-full transition-colors"
                 onClick={() => handleShowAddonsSelection (index)}
                 title="View area breakdown"
               >
                 <FontAwesomeIcon icon={faInfoCircle} className="h-4 w-4" />
               </button>
                ) }
            </div>
          </td>
  
    <td className="border-r border-b px-2 py-2">
  <div className="flex justify-between items-center">
    <div className="outline-blue-500 text-sm w-full h-full p-1 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90">
      {item?.specifications ? (
        <div className="max-h-12 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
          {typeof item.specifications === 'string' && (
            <>
              {(() => {
                try {
                  const specs = JSON.parse(item.specifications);
                  if (Array.isArray(specs) && specs.length > 0 && 
                      Object.keys(specs[0]).some(key => key.trim() !== '' && specs[0][key].trim() !== '')) {
                    return (
                      <>
                        {specs.slice(0, 2).map((spec, index) => (
                          <div key={index} className="text-sm mb-1">
                            {Object.entries(spec).map(([key, value]) => (
                              key.trim() !== '' && value.trim() !== '' &&
                              <span key={key} className="mr-1">
                                {key}: {value}
                              </span>
                            ))}
                          </div>
                        ))}
                        {specs.length > 2 && (
                          <div>
                            {specs.slice(2).map((spec, index) => (
                              <div key={index} className="text-sm mb-1">
                                {Object.entries(spec).map(([key, value]) => (
                                  key.trim() !== '' && value.trim() !== '' &&
                                  <span key={key} className="mr-1">
                                    {key}: {value}
                                  </span>
                                ))}
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    );
                  }
                  return '-';
                } catch (error) {
                  return 'No Specifications';
                }
              })()}
            </>
          )}
        </div>
      ) : '-'}
    </div>
    <div
      className="cursor-pointer ml-2 p-1 hover:bg-gray-100 rounded-full"
      onClick={() => handleOpenSpecification(item, index)}
    >
      <FontAwesomeIcon icon={faEllipsisH} className="text-gray-500" />
    </div>
  </div>
</td>

    
         {/*  {selectedQuoteType?.value === 'Group' && (
            <>
              {(selectedProductCategory?.label === 'Tiles' ||
                selectedProductCategory?.label === 'Doors' ||
                selectedProductCategory?.label === 'Windows') && (
                <>
                  <td className="border-r border-b p-2">
                    <div className="relative">
                      <div
                        className="flex justify-between items-center p-2 border bg-white border-gray-300 rounded-md cursor-pointer shadow-sm hover:border-blue-400 transition-colors"
                        onClick={() => setActiveDropdown(index === activeDropdown ? null : index)}
                      >
                        <span className="text-sm truncate max-w-[120px]">
                          {item?.application_areas?.length > 0
                            ? `${item.application_areas.length} areas selected`
                            : 'Select Areas'}
                        </span>
                        <FontAwesomeIcon icon={faChevronDown} className="w-3 h-3 text-gray-500 flex-shrink-0" />
                      </div>
                      
                      {activeDropdown === index && (
                        <div className="absolute z-50 left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                          <div className="p-2 border-b">
                            <input
                              type="text"
                              className="w-full p-2 border rounded focus:outline-none focus:border-blue-500 text-sm"
                              placeholder="Search areas..."
                              onChange={(e) => {
                                setSearchTerm(e.target.value.toLowerCase());
                              }}
                              autoFocus
                            />
                          </div>
                          
                          {Object.keys(AreaMeasurementsData)
                            .map((key) => {
                              const value = AreaMeasurementsData[key][0];
                              const count = AreaMeasurementsData[key].length > 1 ? `${AreaMeasurementsData[key].length - 1}` : '';
                              const quantity = AreaMeasurementsData[key][1];
                              return {
                                label: `${key} - ${value} ${count}`,
                                area: value,
                                areaName: key,
                                count: quantity,
                              };
                            })
                            .filter(option => {
                              // Filter by search term
                              if (searchTerm && !option.areaName.toLowerCase().includes(searchTerm)) {
                                return false;
                              }
                              
                              const category_mapping_id = parseFloat(categoriesToDisplay.find(p => p._id === selectedProductCategory.value)?.category_mapping_id);
                              
                              // Apply category-specific filters
                              if (category_mapping_id === 3) { // Windows
                                if (selectedApplicationAreas['Bedroom Windows Area'] && option.areaName.startsWith('Bedroom') && option.areaName !== 'Bedroom Windows Area') return false;
                                if (selectedApplicationAreas['Ventilators Area'] && option.areaName.startsWith('Bathroom') && option.areaName !== 'Ventilators Area') return false;
                              } else if (category_mapping_id === 2) { // Doors
                                if (selectedApplicationAreas['Bedroom Doors Area'] && option.areaName.startsWith('Bedroom') && option.areaName !== 'Bedroom Doors Area') return false;
                                if (selectedApplicationAreas['Bathroom Doors Area'] && option.areaName.startsWith('Bathroom') && option.areaName !== 'Bathroom Doors Area') return false;
                              } else if (category_mapping_id === 1) { // Tiles
                                if (selectedApplicationAreas['Balcony Flooring'] && option.areaName.startsWith('Balcony') && option.areaName !== 'Balcony Flooring') return false;
                                if (selectedApplicationAreas['Total Bedrooms Flooring'] && option.areaName.includes('Bedroom') && option.areaName.includes('Flooring') && option.areaName !== 'Total Bedrooms Flooring') return false;
                                if (selectedApplicationAreas['Total Bathrooms Walls'] && option.areaName.includes('Bathroom') && option.areaName.includes('Walls') && option.areaName !== 'Total Bathrooms Walls') return false;
                                if (selectedApplicationAreas['Total Bathrooms Flooring'] && option.areaName.includes('Bathroom') && option.areaName.includes('Flooring') && option.areaName !== 'Total Bathrooms Flooring') return false;
                              }
                              
                              return true;
                            })
                            .map((option, optionIndex) => {
                              const isSelected = item?.application_areas?.some(area => area.area_name === option.areaName);
                              console.log('option.areaName', option);
                              return (
                                <div
                                  key={optionIndex}
                                  className={`p-2 cursor-pointer text-sm hover:bg-blue-100 ${isSelected ? 'bg-blue-50' : ''}`}
                                  onClick={() => handleMultipleAreaSelection(index, option)}
                                >
                                  <div className="flex items-center">
                                    <input
                                      type="checkbox"
                                      checked={isSelected}
                                      onChange={() => {}}
                                      className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                    />
                                    <span className="truncate max-w-[180px]">{option.label}</span>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                  </td>
                  
              
          <td className="border-r border-b p-2">
            {item?.application_areas?.length > 0 ? (
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  {selectedProductCategory?.label === 'Tiles' ? (
                    <span className="text-sm font-medium">{formatNumber(item.total_area || 0)} sq.ft</span>
                  ) : (
                    <span className="text-sm font-medium">{item.total_count || 0} nos</span>
                  )}
                </div>
                <button 
                  className="ml-2 p-1 text-blue-500 hover:bg-blue-50 rounded-full transition-colors"
                  onClick={() => handleShowAreaBreakdown(index)}
                  title="View area breakdown"
                >
                  <FontAwesomeIcon icon={faInfoCircle} className="h-4 w-4" />
                </button>
              </div>
            ) : (
              <div className="text-xs text-gray-500 text-center py-2">No areas selected</div>
            )}
          </td>
          
          
                </>
              )}
            </>
          )} */}

{selectedQuoteType?.value === 'Group' && (
  <>
    {(selectedProductCategory?.label === 'Tiles' ||
      selectedProductCategory?.label === 'Doors' ||
      selectedProductCategory?.label === 'Windows') && (
      <>
        <td className="border-r border-b p-2">
          <div className="relative">
            <div
              className="flex justify-between items-center p-2 border bg-white border-gray-300 rounded-md cursor-pointer shadow-sm hover:border-blue-400 transition-colors"
              onClick={() => setActiveDropdown(index === activeDropdown ? null : index)}
            >
              <span className="text-sm truncate max-w-[120px]">
                {item?.application_areas?.length > 0
                  ? `${item.application_areas.length} areas selected`
                  : 'Select Areas'}
              </span>
              <FontAwesomeIcon icon={faChevronDown} className="w-3 h-3 text-gray-500 flex-shrink-0" />
            </div>
            
            {activeDropdown === index && (
  <div className="absolute z-50 left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-72 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
    <div className="p-2 border-b">
      <input
        type="text"
        className="w-full p-2 border rounded focus:outline-none focus:border-blue-500 text-sm"
        placeholder="Search areas..."
        onChange={(e) => {
          setSearchTerm(e.target.value.toLowerCase());
        }}
        autoFocus
      />
    </div>
    
    {/* Sort and display the area measurements */}
    {(() => {
      // Create a sorted copy of AreaMeasurementsData
      const sortedAreaData = [...AreaMeasurementsData].sort((a, b) => {
        const areaNameA = selectedProductCategory?.label?.toLowerCase() === 'tiles' ? a.area_name : a.asset_name || a.area_name;
        const areaNameB = selectedProductCategory?.label?.toLowerCase() === 'tiles' ? b.area_name : b.asset_name || b.area_name;
        
        // Check if selected in current row
        const isSelectedA = selectedProductCategory?.label?.toLowerCase() === 'tiles'
          ? rows[index]?.application_areas?.some(area => area.area_name === a.area_name)
          : rows[index]?.application_areas?.some(area => area.asset_name === (a.asset_name || a.area_name));
          
        const isSelectedB = selectedProductCategory?.label?.toLowerCase() === 'tiles'
          ? rows[index]?.application_areas?.some(area => area.area_name === b.area_name)
          : rows[index]?.application_areas?.some(area => area.asset_name === (b.asset_name || b.area_name));
        
        // Check if selected in other rows
        const isUsedElsewhereA = rows.some((row, rowIdx) => {
          if (rowIdx === index) return false;
          return selectedProductCategory?.label?.toLowerCase() === 'tiles'
            ? row?.application_areas?.some(area => area.area_name === a.area_name)
            : row?.application_areas?.some(area => area.asset_name === (a.asset_name || a.area_name));
        });
        
        const isUsedElsewhereB = rows.some((row, rowIdx) => {
          if (rowIdx === index) return false;
          return selectedProductCategory?.label?.toLowerCase() === 'tiles'
            ? row?.application_areas?.some(area => area.area_name === b.area_name)
            : row?.application_areas?.some(area => area.asset_name === (b.asset_name || b.area_name));
        });
        
        // Sort priority: 1. Selected in current row, 2. Not used elsewhere, 3. Alphabetical
        if (isSelectedA && !isSelectedB) return -1;
        if (!isSelectedA && isSelectedB) return 1;
        if (!isUsedElsewhereA && isUsedElsewhereB) return -1;
        if (isUsedElsewhereA && !isUsedElsewhereB) return 1;
        return areaNameA.localeCompare(areaNameB);
      });
      
      // Map the sorted data to JSX elements
      return sortedAreaData.map((item, idx) => {
        // Create option object from the correct data structure
        const areaNameData = selectedProductCategory?.label?.toLowerCase() === 'tiles'
          ? item.area_name
          : item.asset_name || item.area_name;
          
        const option = {
          label: `${areaNameData} - ${item.areaInSft} sq.ft`,
          area: item.areaInSft,
          areaName: item.area_name,
          count: item.asset_count || 0,
          asset_name: item.asset_name || '',
          room_name: item.room_name || '',
          height: item.height || 0,
          width: item.width || 0,
          unit: item.unit || ''
        };
        
        // Filter by search term
        if (searchTerm && !areaNameData.toLowerCase().includes(searchTerm.toLowerCase())) {
          return null;
        }
        
        const category_mapping_id = parseFloat(categoriesToDisplay.find(p => p._id === selectedProductCategory.value)?.category_mapping_id);
        
        // Apply category-specific filters
        if (category_mapping_id === 3) { // Windows
          if (selectedApplicationAreas['Bedroom Windows Area'] && option.areaName.startsWith('Bedroom') && option.areaName !== 'Bedroom Windows Area') return null;
          if (selectedApplicationAreas['Ventilators Area'] && option.areaName.startsWith('Bathroom') && option.areaName !== 'Ventilators Area') return null;
        } else if (category_mapping_id === 2) { // Doors
          if (selectedApplicationAreas['Bedroom Doors Area'] && option.areaName.startsWith('Bedroom') && option.areaName !== 'Bedroom Doors Area') return null;
          if (selectedApplicationAreas['Bathroom Doors Area'] && option.areaName.startsWith('Bathroom') && option.areaName !== 'Bathroom Doors Area') return null;
        } else if (category_mapping_id === 1) { // Tiles
          if (selectedApplicationAreas['Balcony Flooring'] && option.areaName.startsWith('Balcony') && option.areaName !== 'Balcony Flooring') return null;
          if (selectedApplicationAreas['Total Bedrooms Flooring'] && option.areaName.includes('Bedroom') && option.areaName.includes('Flooring') && option.areaName !== 'Total Bedrooms Flooring') return null;
          if (selectedApplicationAreas['Total Bathrooms Walls'] && option.areaName.includes('Bathroom') && option.areaName.includes('Walls') && option.areaName !== 'Total Bathrooms Walls') return null;
          if (selectedApplicationAreas['Total Bathrooms Flooring'] && option.areaName.includes('Bathroom') && option.areaName.includes('Flooring') && option.areaName !== 'Total Bathrooms Flooring') return null;
        }
        
        // Determine if the item is selected based on product category
        let isSelected = false;
        if (selectedProductCategory?.label?.toLowerCase() === 'tiles') {
          isSelected = rows[index]?.application_areas?.some(area => area.area_name === option.areaName);
        } else {
          isSelected = rows[index]?.application_areas?.some(area => area.asset_name === option.asset_name);
        }
        
        // Check if used in other rows
        const isUsedElsewhere = rows.some((row, rowIdx) => {
          if (rowIdx === index) return false; // Skip current row
          
          return selectedProductCategory?.label?.toLowerCase() === 'tiles'
            ? row?.application_areas?.some(area => area.area_name === option.areaName)
            : row?.application_areas?.some(area => area.asset_name === option.asset_name);
        });
        
        return (
          <div
            key={idx}
            className={`p-2 cursor-pointer text-sm hover:bg-blue-100 ${isSelected ? 'bg-blue-50' : ''} ${isUsedElsewhere && !isSelected ? 'bg-gray-50' : ''}`}
            onClick={() => handleMultipleAreaSelection(index, option)}
          >
            <div className="flex items-start">
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => {}} // Empty onChange handler since click is handled by the parent div
                className="mr-2 h-4 w-4 mt-0.5 flex-shrink-0 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <div className="flex flex-col">
                <div className="flex items-center">
                  <span className="text-xs leading-tight">{areaNameData}</span>
                  {isUsedElsewhere && !isSelected && (
                    <div className="ml-1 w-2 h-2 rounded-full bg-amber-400" title="Used in another row"></div>
                  )}
                </div>
                <span className="text-xs text-gray-500 leading-tight">
                  {item.areaInSft && `${item.areaInSft} sq.ft`}
                  {item.asset_count > 0 && ` • ${item.asset_count} nos`}
                </span>
              </div>
            </div>
          </div>
        );
      }).filter(Boolean);
    })()}
  </div>
)}


            
          </div>
        </td>
        
        <td className="border-r border-b p-2">
          {item?.application_areas?.length > 0 ? (
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                {selectedProductCategory?.label === 'Tiles' ? (
                  <span className="text-sm font-medium">{formatNumber(item.total_area || 0)} sq.ft</span>
                ) : (
                  <span className="text-sm font-medium">{item.total_count || 0} nos</span>
                )}
              </div>
              <button 
                className="ml-2 p-1 text-blue-500 hover:bg-blue-50 rounded-full transition-colors"
                onClick={() => handleShowAreaBreakdown(index)}
                title="View area breakdown"
              >
                <FontAwesomeIcon icon={faInfoCircle} className="h-4 w-4" />
              </button>
            </div>
          ) : (
            <div className="text-xs text-gray-500 text-center py-2">No areas selected</div>
          )}
        </td>
      </>
    )}
  </>
)}


       <td className="border-r border-b px-2 py-2">
                <input
                  type="text"
                  value={item?.quantity}
                  onChange={(e) => handleInputChange(e.target.value, index, 'quantity' , products.find(p=>p.item_id === item?.item_id)?.selling_price )}
                  className="outline-blue-500 text-right text-sm w-full h-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                />
              </td>
              <td className="border-r border-b px-2 py-2">
                {/* <input
                  type="text"
                  value={item.UOM}
                  onChange={(e) => handleInputChange(e, index, 'UOM')}
                  className="outline-blue-500 text-sm w-full h-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                /> */}
                <td className="w-20">
  {/* <TableSearchDropDown
    options={UomOptions}
    value={item.UOM}
    onChange={(selectedOption) => handleUomChange(index, selectedOption)}
  /> */}
   <input
                  type="text"
                  value={item?.UOM} 
                  readOnly
                  //onChange={(e) => handleInputChange(e, index, 'UOM')}
                  className="outline-blue-500 text-sm w-full h-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                />
</td>
              </td>
              <td className="border-r border-b px-2 py-2">
               <input
                type="text"
                value={item?.price}
                onChange={(e) => handleInputChange(e.target.value, index, 'price', e.target.value)} 
                className="outline-blue-500 text-right text-sm w-full h-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                 />
                  {selectedPricList && (
                  <td className="px-2 py-2">
                    <div className="w-48">
                      <CustomDropdown
                         options={priceLists.map(priceList => ({
                          value: priceList?.priceList?._id,
                          label: priceList?.priceList?.price_list_name
                        }))}
                        selected={allRowsSelectedPriceList[index]||rowPricelists}
                        onSelect={(option) => handleRowPriceListSelect(index, option , item)}
                        showAddNew={false}
                        placeholder="Apply Price List"
                        showSearch={true}
                      />
                    </div>
                  </td>
                )}
              </td>
             
              <td className="border-r border-b px-2 py-2">
              {/*   <input
                  type="text"
                  value={item?.tax}
                  onChange={(e) => handleInputChange(e, index, 'tax')}
                  className="outline-blue-500 text-right text-sm w-full h-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                /> */}
                <div className="w-22">
                <TableSearchDropDown
          options={Taxes.map(tax => ({
            value: tax.name,  // Set tax name as the value
            label: tax.value, // Set tax value as the label
          }))}
          value={ item?.tax_type}
          onChange={(selectedOption) => {
            // Make sure the selectedOption is passed correctly
            handleTaxChange(
              index,
              selectedOption,
              products.find(p => p.item_id === item.item_id)?.[selectedOption.value],
              item?.price,
              item?.quantity
            );
          }}
        />
         </div>
              </td>
              <td className="border-b border-r px-2 py-2">
  <input
    type="text"
    value={formatNumber(item?.price * item?.quantity || item?.total || 0)}
    readOnly
    //onChange={(e) => handleAmountInputChange(e, index, 'amount')}
    className="outline-blue-500 text-right text-sm w-full h-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
  />
</td>

              {selectedQuoteType?.value === 'Group' && (
            <>
              {(selectedProductCategory?.label === 'Tiles' ||
                selectedProductCategory?.label === 'Doors' ||
                selectedProductCategory?.label === 'Windows') && (
                <>
                  {/* <td className="border-b  px-2 py-2">
                <div
                  className="px-2 py-1 border rounded-md cursor-pointer text-center"
                  onClick={() => handleSelectDesignPopup(index)}
                >
                  Select
                </div>
              </td> */}
             
                </>
              )}
            </>
          )}

                  <td className="px-2">  
                    <button    type="button"
                                  onClick={() => deleteRow(index ,rows)}
                                  className="text-red-500">
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </td>
            </tr>
          ))}
        </tbody>
      </table>
</div>
              </div>
              </div>
              </div>
              <div className='pt-2 px-6 py-6 flex flex-row justify-between w-full'>
              <div class="flex flex-col">
                <div><button  onClick={addRow} className='rounded-md px-2 py-2 bg-[#F7F7FE] text-sm'><FontAwesomeIcon icon={faPlusCircle} className="text-[#408dfb] mx-1"  />
                Add New Row</button></div> 

               {/* Pending Areas Information Section */}
    <div className="mt-4 bg-gray-50 p-3 rounded-md border border-gray-200 max-w-md">
      <div className="flex items-center mb-2">
        <FontAwesomeIcon icon={faInfoCircle} className="text-blue-500 mr-2" />
        <h3 className="text-sm font-medium">Unassigned Areas</h3>
      </div>
      
      {(() => {
        // Get all available areas from measurements data
        const allAreas = AreaMeasurementsData.map(item => {
          return {
            name: selectedProductCategory?.label?.toLowerCase() === 'tiles' 
              ? item.area_name 
              : item.asset_name || item.area_name,
            id: selectedProductCategory?.label?.toLowerCase() === 'tiles' 
              ? item.area_name 
              : item.asset_name || item.area_name,
            area: item.areaInSft,
            count: item.asset_count || 0
          };
        });
        
        // Get all areas that are already applied in any row
        const appliedAreas = rows.flatMap(row => 
          row.application_areas?.map(area => 
            selectedProductCategory?.label?.toLowerCase() === 'tiles' 
              ? area.area_name 
              : area.asset_name
          ) || []
        );
        
        // Filter to get only pending/unused areas
        const pendingAreas = allAreas.filter(area => !appliedAreas.includes(area.id));
        
        // If no pending areas, show a message
        if (pendingAreas.length === 0) {
          return (
            <p className="text-xs text-gray-500">All areas have been applied to products.</p>
          );
        }
        
        // Show the first 3 pending areas with a count of remaining
        const displayCount = 3;
        const displayAreas = pendingAreas.slice(0, displayCount);
        const remainingCount = pendingAreas.length - displayCount;
        
        return (
          <>
            <ul className="text-xs text-gray-600 space-y-1 ml-6 list-disc">
              {displayAreas.map((area, idx) => (
                <li key={idx}>
                  {area.name}
                  <span className="text-gray-500 ml-1">
                    ({area.area} sq.ft{area.count > 0 ? `, ${area.count} nos` : ''})
                  </span>
                </li>
              ))}
            </ul>
            {remainingCount > 0 && (
              <p className="text-xs text-blue-500 mt-1 font-medium">
                + {remainingCount} more areas available
              </p>
            )}
           <div className="mt-2 flex items-center text-xs"><span className="text-gray-500 flex items-center">Areas marked with <div className="w-2 h-2 rounded-full bg-amber-400 mx-1"></div> are already assigned</span></div>

          </>
        );
      })()}
    </div>
     
     </div>

                <div className='p-6 space-y-6 flex flex-col justify-between rounded-md w-1/2 bg-[#F7F7FE]'>
                <div className='flex justify-between'>
                    <div>

                <p className='text-sm font-semibold'>Sub Total</p>
                </div>
                <div><p className='text-sm font-semibold'>{formatNumber(SubTotal)}</p></div>
                </div>
                <div className='flex justify-between'>
                <div className='flex flex-row items-center'>
  <p className='text-sm'>Discount</p>
  <div className='flex justify-end w-full relative'>
  <input 
    type="text"
    value={amendedDiscount}
    onChange={(e) => {
      const currentValue = e.target.value;
      const newValue = currentValue.replace(/[^0-9]/g, ''); // remove non-numeric characters
      setDiscountPercentage(newValue);
      setAmendedDiscount(newValue);
    }}
    className='px-2 text-right border border-gray-300 outline-blue-500 hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90 py-1 w-1/3 border-r-0 rounded-l-md'
  />
  <span className='bg-gray-200 p-2 text-sm border border-gray-300 border-l-0 rounded-r-md'>%</span>
</div>
</div>
<div>
  <p className='text-sm '>
    <span className='mr-1 font-bold text-xl text-red-500'>-</span>
    {formatNumber(Number.isFinite(parseFloat(SubTotal)) && Number.isFinite(parseFloat(amendedDiscount)) ? parseFloat(SubTotal) * (parseFloat(amendedDiscount / 100)) : 0)}
  </p>
</div>
                </div>
                <div className='flex justify-between'>
                    <div>
                <p className='text-sm '>Tax</p>
                </div>
                <div><p className='text-sm font-semibold'>{formatNumber(calculateTotalTaxAmount())}</p></div>
                </div>
                <div className='flex justify-between'>
                    <div className='flex flex-row justify-between'>
                <p className='text-sm '>Adjustment</p>
                <div className='flex justify-end w-full relative'>
                <input
  type="text"
  value={amendedPrice}
  onChange={(e) => {
    const regex = /^[-+]?[0-9]*$/; // allow optional - or +, followed by digits
    if (regex.test(e.target.value)) {
      setAmendedPrice(e.target.value);
    }
  }}
  className='px-2 w-[50%] text-right py-1 w-2/3 outline-blue-500 border border-gray-300 rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90'
/>

  <button 
  className="mr-2 text-white px-1 py-0.5 rounded-md" 
  title="" info-tooltip="Add any other +ve or -ve value that need to be applied to adjust the total amount of the transaction Eg. +10 or -10."  style={{ '--tooltip-bg': 'black' }}>
  <FontAwesomeIcon icon={faQuestionCircle}  className="word-break break-words mb-0.5 text-xs text-gray-500 mx-1 cursor-pointer" />
</button>
</div>
                </div>
                <div><p className='text-sm '>{amendedPrice ? amendedPrice : '0.00'}</p></div>
                </div>
                <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
                <div className='flex justify-between'>
                    <div className='flex flex-row justify-between'>
                <p className='text-lg font-semibold '>Total ( ₹ )</p>
                </div>
                <div><p className='text-lg font-semibold'>{formatNumber(total)}</p></div>
                </div>
                </div>
                </div>
              </div>
              <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
          <button className="px-2 py-1 bg-[#f7525a] text-white border border-[#DDDDDD] rounded-md"
          onClick={handleSaveQuotationData} >
            Save {isSaving && <Spinner />} 
            </button>
            {/* <button className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md"
           onClick={handleSubmitUomData} >
            Save and Send  {isSaving && <Spinner />}
            </button> */}
            <button onClick={handleCancel}  className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
          isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
        }`}
        disabled={isSaving}>
          Cancel</button>
       </div>
      </div>
            </div>
          </div>
        </div>
      </div>

{/* pop up starts */}
{showDesignSelectPopup && (
      <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
        <div className="bg-white rounded-b-md shadow-md w-1/2 h-2/3 flex flex-col">
          <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[18%] px-6'>
            <h2 className="text-md">Select Design</h2>
            <input
              type="text"
              className="p-1 border rounded-md border-blue-500 focus:outline-none hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button onClick={handleClosePopup} className="text-white px-1 py-1 rounded-md">   
              <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer" />
            </button>
          </div>
          <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
         
         <div className="flex flex-wrap p-4 overflow-auto">
    {SelectedItemRow?.sub_items && SelectedItemRow?.sub_items
      .filter((design) =>
        design.sub_item_name.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .map((design) => {
        const isSelected = rows[SelectedItemRowIndex]?.selectedDesigns?.some(
          (d) => d.sub_item_id === design.sub_item_id
        );

        return (
          <div key={design.id} className="w-1/3 p-2">
            <div
              className={`border rounded-md p-2 ${
                isSelected ? "border-blue-500" : "border-gray-300"
              }`}
            >
              <img
                src={imageUrl + design?.sub_item_image}
                alt={design?.sub_item_image}
                className="w-full h-32 object-cover rounded-md"
              />
              <h3 className="text-center mt-2">{design?.sub_item_name}</h3>
              <div className="flex items-center justify-center mt-2">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleSelectDesign(design)}
                />
                <span className="ml-2">Select</span>
              </div>
              {isSelected && (
                <div className="flex justify-between items-center">
                  <label
                    htmlFor={`quantity-${design.id}`}
                    className="mt-2 block text-sm font-regular text-center text-gray-700"
                  >
                    Quantity:
                  </label>
                  <input
                    type="number"
                    id={`quantity-${design.id}`}
                    value={
                      rows[SelectedItemRowIndex]?.selectedDesigns?.find((d) => d.sub_item_id === design.sub_item_id)?.sub_item_quantity || ''
                    }
                    onChange={(e) =>
                      handleQuantityChangeForDesign(
                        design.sub_item_id,
                        design.id,
                        parseInt(e.target.value, 10)
                      )
                    }
                    className="w-1/3 p-1 border rounded-md"
                    min="1"
                  />
                  {SelectedItemRow?.UOM}
                </div>
              )}
            </div>
          </div>
        );
      })}
  </div>

          <div className="mt-auto w-full">
            <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
            <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
              <button className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md">
                Save
              </button>
              <button onClick={handleClosePopup} className="px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    )}

{showSpecificationsPopup && (
  <div className="pt-2 pb-2 fixed z-50 inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div 
      className="bg-white rounded-b-md shadow-md w-full h-full flex flex-col animate-slide-in"
      style={{ maxWidth: '70vw', maxHeight: '70vh' }}
    >
      <div className="bg-[#F9F9FB] flex justify-between items-center w-full h-[12%] px-6">
        <h1 className="text-md font-semibold">Specifications</h1>
        <button onClick={() => setShowSpecificationsPopup(false)} className="text-white px-1 py-1 rounded-md">
          <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
        </button>
      </div>
      
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      
      <div className="flex-1 overflow-y-auto px-6 py-4">
        {rows.length > 0 ? (
          <table className="w-full">
            <thead>
              <tr className="text-[#6c7184] bg-[#fafafc]">
                <th className="font-semibold text-left text-sm py-2 px-2 border cursor-pointer">SNo</th>
                <th className="font-semibold text-left text-sm py-2 px-2 border cursor-pointer">Name</th>
                <th className="font-semibold text-left text-sm py-2 px-2 border cursor-pointer">Value</th>
              </tr>
            </thead>
            <tbody>
  {selectedSpecifications?.map((spec, index) => (
    <tr key={index}>
      <td className="border p-2">{spec.id}</td>
      <td className="border p-2">
        <input
          type="text"
          value={spec.name}
          onChange={(e) => {
            const updatedSpecs = [...selectedSpecifications];
            updatedSpecs[index].name = e.target.value;
            setSelectedSpecifications(updatedSpecs);
          }}
          className="outline-blue-500 text-sm w-full h-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
        />
      </td>
      <td className="border p-2">
        <input
          type="text"
          value={spec.value}
          onChange={(e) => {
            const updatedSpecs = [...selectedSpecifications];
            updatedSpecs[index].value = e.target.value;
            setSelectedSpecifications(updatedSpecs);
          }}
          className="outline-blue-500 text-sm w-full h-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
        />
      </td>
       <td className="px-2">
                                      <button
                                        type="button"
                                        onClick={() => deleteSpecificationRow(index)}
                                        className="text-red-500"
                                      >
                                        <FontAwesomeIcon icon={faTrash} />
                                      </button>
                                    </td>
    </tr>
  ))}
</tbody>


          </table>
        ) : (
          <div className="text-center py-4">
            <p>No Specifications</p>
          </div>
        )}
      </div>
       <div className="mt-4">
                        <button
                          onClick={addSpecificationRow}
                          className="text-blue-500 py-2 px-4"
                        >
                          <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
                          Add Specifications
                        </button>
                      </div>

      <hr className="border-t border-gray-200" style={{ borderTopWidth: '1px' }} />

      <div className="flex justify-between px-6 py-4">
        
        <div className="flex space-x-4">
          <button onClick={handleSaveSpecifications} className="text-sm px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md">
            Save
          </button>
          <button onClick={() => setShowSpecificationsPopup(false)} className="text-sm border hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{showBreakdownForIndex !== null && rows[showBreakdownForIndex]?.application_areas?.length > 0 && (
  <div className="pt-2 pb-2 fixed z-50 inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div
      className="bg-white rounded-b-md shadow-md w-full h-full flex flex-col animate-slide-in"
      style={{ maxWidth: '70vw', maxHeight: '80vh' }}
    >
      {/* Header */}
      <div className="bg-[#F9F9FB] flex justify-between items-center w-full py-3 px-6">
        <div className="flex items-center">
          <h1 className="text-md font-semibold mr-4">
            {selectedProductCategory?.label === 'Tiles' ? 'Area Breakdown' : 'Count Breakdown'}
          </h1>
          <div className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-xs font-medium">
            Total: {selectedProductCategory?.label === 'Tiles'
              ? `${formatNumber(rows[showBreakdownForIndex].total_area || 0)} sq.ft`
              : `${rows[showBreakdownForIndex].total_count || 0} nos`}
          </div>
        </div>
        <button onClick={handleCloseBreakdown} className="text-gray-500 hover:text-red-500">
          <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A]" />
        </button>
      </div>
      
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      
      <div className="flex-1 overflow-y-auto">
        {/* Instructions */}
        <div className="mx-6 mt-3 mb-3 bg-blue-50 p-3 rounded-md border border-blue-200 text-sm">
          <p className="font-medium text-blue-700">
            <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
            {selectedProductCategory?.label !== 'Windows'
              ? "Step 1: Select areas by checking the boxes. Step 2: Choose a design and apply it. Step 3: Click 'Save Changes' when done."
              : "Manage your window counts below and click 'Save Changes' when done."}
          </p>
        </div>
        
        {/* Areas Table with Selection */}
        <div className="px-6">
          <table className="w-full mb-4">
            <thead>
              <tr className="text-[#6c7184] bg-[#fafafc]">
                <th className="font-semibold text-center text-sm py-2 px-2 border w-12">
                  {selectedProductCategory?.label !== 'Windows' && (
                    <input
                      type="checkbox"
                      checked={rows[showBreakdownForIndex].application_areas.every(area => area.isSelected)}
                      onChange={(e) => {
                        const updatedRows = [...rows];
                        updatedRows[showBreakdownForIndex].application_areas.forEach((area, idx) => {
                          updatedRows[showBreakdownForIndex].application_areas[idx].isSelected = e.target.checked;
                        });
                        setRows(updatedRows);
                      }}
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                  )}
                </th>
                <th className="font-semibold text-left text-sm py-2 px-2 border w-10">SNo</th>
                <th className="font-semibold text-left text-sm py-2 px-2 border">
                  {selectedProductCategory?.label === 'Tiles' ? 'Area Name' : 'Asset Name'}
                </th>
                <th className="font-semibold text-right text-sm py-2 px-2 border w-32">
                  {selectedProductCategory?.label === 'Tiles' ? 'Area (sq.ft)' : 'Count (nos)'}
                </th>
                {selectedProductCategory?.label !== 'Windows' && (
                  <th className="font-semibold text-center text-sm py-2 px-2 border w-48">Current Design</th>
                )}
                <th className="font-semibold text-center text-sm py-2 px-2 border w-24">Action</th>
              </tr>
            </thead>
            <tbody>
              {rows[showBreakdownForIndex].application_areas.map((area, idx) => {
                // Determine which name to display based on product category
                const displayName = selectedProductCategory?.label === 'Tiles'
                  ? area.area_name
                  : (area.asset_name || area.area_name);
                
                return (
                  <tr key={idx} className={area.isSelected ? "bg-blue-50" : ""}>
                    <td className="border p-2 text-center">
                      {selectedProductCategory?.label !== 'Windows' && (
                        <input
                          type="checkbox"
                          checked={area.isSelected || false}
                          onChange={(e) => {
                            const updatedRows = [...rows];
                            updatedRows[showBreakdownForIndex].application_areas[idx].isSelected = e.target.checked;
                            setRows(updatedRows);
                          }}
                          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                      )}
                    </td>
                    <td className="border p-2 text-center">{idx + 1}</td>
                    <td className="border p-2">{displayName}</td>
                    <td className="border p-2 text-right">
                      <input
                        type="text"
                        value={selectedProductCategory?.label === 'Tiles' ? area.areaInSft : area.asset_count}
                        onChange={(e) => {
                          const updatedRows = [...rows];
                          if (selectedProductCategory?.label === 'Tiles') {
                            updatedRows[showBreakdownForIndex].application_areas[idx].areaInSft = e.target.value;
                          } else {
                            updatedRows[showBreakdownForIndex].application_areas[idx].asset_count = e.target.value;
                          }
                          setRows(updatedRows);
                          // Recalculate totals after changing the value
                         // handleRecalculateAreaTotals(showBreakdownForIndex);
                        }}
                        className="outline-blue-500 text-right text-sm w-full h-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                      />
                    </td>
                    {selectedProductCategory?.label !== 'Windows' && (
                      <td className="border p-2 text-center">
                        {area.selected_design?.design_name ? (
                          <div className="flex items-center justify-center">
                            {area.selected_design.design_image && (
                              <img
                                src={imageUrl + area.selected_design.design_image}
                                alt={area.selected_design.design_name}
                                className="h-8 w-8 object-cover rounded-md mr-2"
                              />
                            )}
                            <span className="text-sm">{area.selected_design.design_name}</span>
                          </div>
                        ) : (
                          <span className="text-sm text-gray-500">No design</span>
                        )}
                      </td>
                    )}
                    <td className="border p-2">
                      <div className="flex justify-center">
                        <button
                          type="button"
                          onClick={() => {
                            // Function to remove area from item
                            const updatedRows = [...rows];
                            updatedRows[showBreakdownForIndex].application_areas.splice(idx, 1);
                            setRows(updatedRows);
                            //handleRecalculateAreaTotals(showBreakdownForIndex);
                          }}
                          className="text-red-500 px-2 py-1 rounded-md hover:bg-red-50"
                        >
                          <FontAwesomeIcon icon={faTrash} className="mr-1" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        
        {/* Design Selection Section - Only for Tiles and Doors */}
        {selectedProductCategory?.label !== 'Windows' && rows[showBreakdownForIndex]?.design_products?.length > 0 && (
          <div className="mx-6 mt-2 border-t pt-3">
            {/* Prominent Design Selection Header */}
            <div className="bg-gray-100 p-3 rounded-t-md border border-gray-300 border-b-0">
              <h2 className="text-md font-semibold text-gray-800">
                <FontAwesomeIcon icon={faPlusCircle} className="mr-2 text-blue-500" />
                Step 2: Select a Design and Apply
              </h2>
            </div>
            
            <div className="border border-gray-300 rounded-b-md p-3 bg-white">
              <div className="grid grid-cols-5 gap-3">
                {rows[showBreakdownForIndex]?.design_products?.map((design, designIdx) => (
                  <div
                    key={designIdx}
                    className={`border rounded-md p-2 cursor-pointer transition-all ${
                      selectedDesigns[showBreakdownForIndex] === design.item_id
                        ? 'border-blue-500 bg-blue-50 shadow-md'
                        : 'border-gray-300 hover:border-blue-300'
                    }`}
                    onClick={() => {
                      // Store the selected design for this row
                      setSelectedDesigns(prev => ({
                        ...prev,
                        [showBreakdownForIndex]: design.item_id
                      }));
                    }}
                  >
                    <div className="flex flex-col items-center">
                      {design.item_image ? (
                        <img
                          src={imageUrl + design.item_image}
                          alt={design.item_name}
                          className="w-full h-16 object-cover rounded-md mb-2"
                        />
                      ) : (
                        <div className="w-full h-16 bg-gray-200 rounded-md mb-2 flex items-center justify-center">
                          <span className="text-gray-500">No Image</span>
                        </div>
                      )}
                      <span className="text-xs font-medium text-center truncate mb-2">{design.item_name}</span>
                      
                      {/* Apply button directly on each design card */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent triggering the parent onClick
                          
                          const updatedRows = [...rows];
                          let anySelected = false;
                          
                          // Apply to selected areas only
                          updatedRows[showBreakdownForIndex].application_areas.forEach((area, idx) => {
                            if (area.isSelected) {
                              anySelected = true;
                              
                              // Create the selected_design object with the proper structure
                              updatedRows[showBreakdownForIndex].application_areas[idx].selected_design = {
                                design_name: design.item_name || '',
                                design_id: design.item_id || '',
                                design_image: design.item_image || '',
                                vendor_id: design.vendor_id || '',
                                vendor_name: design.vendor_name || '',
                                design_price: parseFloat(design.selling_price) || 0,
                                design_cost_price: parseFloat(design.cost_price) || 0
                              };
                              
                              // Unselect the area after applying
                              updatedRows[showBreakdownForIndex].application_areas[idx].isSelected = false;
                            }
                          });
                          
                          if (!anySelected) {
                            // Show a message that no areas are selected
                            alert("Please select at least one area to apply the design");
                            return;
                          }
                          
                          setRows(updatedRows);
                          // Set a flag to indicate changes need to be saved
                          
                          setHasUnsavedChanges(true);
                        }}
                        className="px-2 py-0.5 border border-[#f7525a] text-[#f7525a] text-xs rounded-md hover:bg-[#fff5f5] transition-colors"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
      
      {/* Footer with Save Button */}
      <div className="border-t py-3 px-6 flex justify-between items-center bg-[#F9F9FB]">
        <div className="flex items-center">
          {hasUnsavedChanges && (
            <div className="text-amber-600 text-sm flex items-center mr-4">
              <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />
              You have unsaved changes
            </div>
          )}
        </div>
        <div className="flex space-x-4">
        <button
  onClick={() => {
    // Save the changes to the quotation
    // This function should update the main quotation data with the changes made in the breakdown
    handleUpdateDesigns(showBreakdownForIndex);
    setHasUnsavedChanges(false);
  }}
  className="text-sm px-4 py-2 bg-[#f7525a] border-[#f7525a] text-white rounded-md hover:bg-[#e54643] flex items-center"
  disabled={isSaving}
>
  {isSaving ? (
    <Spinner className="mr-2" />
  ) : (
    <FontAwesomeIcon icon={faSave} className="mr-2" />
  )}
  Save Changes
</button>

          <button
            onClick={handleCloseBreakdown}
            className="text-sm border hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-4 py-2 rounded-md"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{showAddonSelectionForIndex !== null && (
  <div className="pt-2 pb-2 fixed z-50 inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div
      className="bg-white rounded-b-md shadow-md w-full h-full flex flex-col animate-slide-in"
      style={{ maxWidth: '70vw', maxHeight: '80vh' }}
    >
      {/* Compact Header */}
      <div className="bg-[#F9F9FB] flex justify-between items-center w-full py-3 px-6">
        <div className="flex items-center">
          <h1 className="text-md font-semibold mr-4">
            Door Addons Selection
          </h1>
          <div className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-xs font-medium">
            Product: {rows[showAddonSelectionForIndex]?.item_name || 'Unknown'}
          </div>
        </div>
        <button
          onClick={() => setShowAddonSelectionForIndex(null)}
          className="text-gray-500 hover:text-red-500"
        >
          <FontAwesomeIcon icon={faX} className="text-xs" />
        </button>
      </div>
      
      <hr className="border-t border-gray-200 w-full" />
      
      <div className="flex-1 overflow-y-auto">
        {/* Clear Instructions */}
        <div className="mx-6 mt-3 mb-3 bg-blue-50 p-3 rounded-md border border-blue-200 text-sm">
          <p className="font-medium text-blue-700">
            <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
            Select addons for this door product. For each subcategory, select a vendor from the dropdown to view available products.
          </p>
        </div>
        
        {/* <div className="mt-2 flex items-center text-xs px-6 mb-4">
          <span className="text-gray-500">
            Areas marked with dot
            <div className="w-2 h-2 rounded-full bg-amber-400 mr-1 inline-block"></div>
            are already assigned
          </span>
        </div>
         */}
        {/* Vendor Selection Dropdowns for each Subcategory - Side by Side */}
        {!isLoadingAddons && Object.keys(subcategoryAddons).length > 0 && (
          <div className="px-6 mb-4">
            <div className="grid grid-cols-2 gap-4">
              {Object.entries(subcategoryAddons).map(([subcategoryId, subcategory]) => {
                // Get the currently selected vendor for this subcategory
                const selectedVendorForSubcategory = subcategory.products.find(
                  product => selectedAddons.includes(product.item_id)
                )?.vendor_id || '';
                
                return (
                  <div key={subcategoryId} className="border rounded-md p-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {subcategory.name}
                    </label>
                    <select
                      className="border rounded-md p-2 w-full"
                      value={selectedVendorForSubcategory}
                      onChange={(e) => {
                        const newVendorId = e.target.value;
                        
                        // If changing vendor, deselect all current selections in this subcategory
                        if (selectedVendorForSubcategory && newVendorId !== selectedVendorForSubcategory) {
                          setSelectedAddons(prev => 
                            prev.filter(id => 
                              !subcategory.products.some(addon => addon.item_id === id && addon.vendor_id === selectedVendorForSubcategory)
                            )
                          );
                        }
                        
                        // If selecting a vendor (not deselecting), select all products from this vendor
                        if (newVendorId) {
                          const vendorProducts = subcategory.products.filter(
                            product => product.vendor_id === newVendorId
                          );
                          
                          // Add all vendor products to selected addons
                          setSelectedAddons(prev => {
                            const newSelected = [...prev];
                            vendorProducts.forEach(product => {
                              if (!newSelected.includes(product.item_id)) {
                                newSelected.push(product.item_id);
                              }
                            });
                            return newSelected;
                          });
                        }
                      }}
                    >
                      <option value="">Select a vendor</option>
                      {subcategory.vendors.map(vendor => (
                        <option key={vendor.vendor_id} value={vendor.vendor_id}>
                          {vendor.vendor_name}
                        </option>
                      ))}
                    </select>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        
        {/* Addons by Subcategory */}
        <div className="px-6">
          {isLoadingAddons ? (
            <div className="flex justify-center items-center p-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            </div>
          ) : (
            <div>
              {Object.keys(subcategoryAddons).length === 0 ? (
                <div className="text-center p-4 text-gray-500">
                  No addon products available.
                </div>
              ) : (
                Object.entries(subcategoryAddons).map(([subcategoryId, subcategory]) => {
                  // Get the currently selected vendor for this subcategory
                  const selectedVendorForSubcategory = subcategory.products.find(
                    product => selectedAddons.includes(product.item_id)
                  )?.vendor_id || '';
                  
                  // If no vendor is selected for this subcategory, don't show the products table
                  if (!selectedVendorForSubcategory) {
                    return null;
                  }
                  
                  // Get all products for the selected vendor in this subcategory
                  const vendorProducts = subcategory.products.filter(
                    product => product.vendor_id === selectedVendorForSubcategory
                  );
                  
                  // Get the vendor name
                  const vendorName = subcategory.vendors.find(
                    vendor => vendor.vendor_id === selectedVendorForSubcategory
                  )?.vendor_name || 'Unknown Vendor';
                  
                  return (
                    <div key={subcategoryId} className="mb-6 border rounded-md overflow-hidden">
                      <h3 className="font-medium text-gray-800 bg-gray-100 p-3 flex justify-between items-center">
                        <span>{subcategory.name}</span>
                        <span className="text-sm bg-blue-50 text-blue-700 px-2 py-1 rounded">
                          Vendor: {vendorName}
                        </span>
                      </h3>
                      
                      <div className="p-3 flex justify-between items-center bg-gray-50">
                        <span className="text-sm font-medium">
                          Products from selected vendor
                        </span>
                        <label className="flex items-center">
                          <input
                            type="checkbox"
                            checked={
                              vendorProducts.length > 0 &&
                              vendorProducts.every(addon => selectedAddons.includes(addon.item_id))
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                // Select all products from this vendor
                                setSelectedAddons(prev => {
                                  const newSelected = [...prev];
                                  vendorProducts.forEach(product => {
                                    if (!newSelected.includes(product.item_id)) {
                                      newSelected.push(product.item_id);
                                    }
                                  });
                                  return newSelected;
                                });
                              } else {
                                // Deselect all products from this vendor
                                setSelectedAddons(prev => 
                                  prev.filter(id => 
                                    !vendorProducts.some(product => product.item_id === id)
                                  )
                                );
                              }
                            }}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded mr-2"
                          />
                          <span className="text-sm">Select All</span>
                        </label>
                      </div>
                      
                      <table className="w-full">
                        <thead>
                          <tr className="text-[#6c7184] bg-[#fafafc]">
                            <th className="font-semibold text-center text-sm py-2 px-2 border w-12">Select</th>
                            <th className="font-semibold text-left text-sm py-2 px-2 border">Addon Name</th>
                            <th className="font-semibold text-left text-sm py-2 px-2 border">Category</th>
                            <th className="font-semibold text-right text-sm py-2 px-2 border w-32">Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vendorProducts.length === 0 ? (
                            <tr>
                              <td colSpan="4" className="text-center p-4 text-gray-500">
                                No products available for the selected vendor.
                              </td>
                            </tr>
                          ) : (
                            vendorProducts.map((addon) => {
                              const isSelected = selectedAddons.includes(addon.item_id);
                              const isAlreadyAssigned = items[showAddonSelectionForIndex]?.product_addons?.some(
                                existingAddon => existingAddon.item_id === addon.item_id
                              );
                              
                              return (
                                <tr
                                  key={addon.item_id}
                                  className={`
                                    ${isSelected ? "bg-blue-50" : ""}
                                    ${isAlreadyAssigned ? "relative" : ""}
                                  `}
                                >
                                  <td className="border p-2 text-center">
                                    <input
                                      type="checkbox"
                                      checked={isSelected}
                                      onChange={() => {
                                        setSelectedAddons(prev => {
                                          if (prev.includes(addon.item_id)) {
                                            return prev.filter(id => id !== addon.item_id);
                                          } else {
                                            return [...prev, addon.item_id];
                                          }
                                        });
                                      }}
                                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                    />
                                    {isAlreadyAssigned && (
                                      <div className="absolute top-1/2 transform -translate-y-1/2 left-1 w-2 h-2 rounded-full bg-amber-400"></div>
                                    )}
                                  </td>
                                  <td className="border p-2">{addon.item_name}</td>
                                  <td className="border p-2">{addon.item_group_name || 'Unknown'}</td>
                                  <td className="border p-2 text-right">₹{formatNumber(addon.selling_price || 0)}</td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  );
                })
              )}
            </div>
          )}
        </div>
      </div>
      
      {/* Compact Footer */}
      <div className="border-t py-3 px-6 flex justify-end">
        <button
          onClick={() => setShowAddonSelectionForIndex(null)}
          className="px-4 py-2 bg-gray-100 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-200 text-sm mr-2"
        >
          Cancel
        </button>
        <button
          onClick={handleApplySelectedAddons}
          className="px-4 py-2 bg-[#f7525a] text-white rounded-md hover:bg-[#e04147] text-sm"
        >
          Apply Selected Addons
        </button>
      </div>
    </div>
  </div>
)}



{showCancelPopup && (
    <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50 ">
    <div className="bg-white rounded-b-md shadow-md w-[550px] h-[250px] flex flex-col" style={{ maxWidth: '550px', maxHeight: '250px' }}>
    <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-14 px-6'>
    <h2 className="text-md font-semibold">
    <FontAwesomeIcon icon={faExclamationTriangle} className="text-xl text-yellow-500 mr-4 " />
      Leave this page?</h2>
      <button onClick={handleStayHere} className="text-white px-1 py-1 rounded-md ">   
        <FontAwesomeIcon icon={faX} className="text-xs text-[#212529] cursor-pointer " />
      </button>
    </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className='pt-4 pl-4 '>
    <div className="w-full items-center p-5">
      <label htmlFor="Other_details" className="block text-sm font-regular text-[#212529] ">
      If you leave, your unsaved changes will be discarded.
      </label>
    </div>  
  </div>
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
        <button className="px-2 py-1 bg-[#408dfb] border-[#f7525a] text-white rounded-md" onClick={handleStayHere}>
  Stay Here  {isSaving && (
      <Spinner/>
    )}
  </button>
          <button onClick={handleLeave} 
          className="hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50  px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md">
            Leave & Discard Changes</button>
        </div>
      </div>
    </div>
  </div>
)}

{showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}
{/* popup ends */}
    </div>
  );
};

export default EditQuote;
